// @flow
import {
    setJoinRoomModalStatus,
    setProtocol,
    setShowHideStatusWebJamMenu,
    setSocketConnectionStatus,
    setUserConnectionStatus,
    setUsersData,
    setVideoScreenStatus,
    saveHostResponse,
    saveRoomEndValue,
    setDeviceListData,
    setData,
    closeVideoCall,
    setMetronomeStatus,
    hideApiLoader,
    showApiLoader,
    setPublicIp,
    setBufferValue,
    setLatencyStatus,
    setclickMakeHost,
    setGhostVoiceSync,
    setAutoMakeHost,
    clickAutoMakeHost,
    setHostRefresh,
    setHostRefreshTimer,
    showToastPopup,
    setStemRecordingUrl,
    setDelayPanning,
    setDeviceUsers,
    setPrevPanning,
    setHostInitWait,
    setThirdPartyHostTabData,
    setHostTabDataMain,
    setRoomorIpAddress,
    saveDeviceListBase
} from "../../customise/redux/tool-webjam/actions";
import { appNavigate } from '../../app/actions';
import { setAudioMuted } from '../../base/media/actions';
import { toState } from "../../base/redux";
import { displayConsole, getPublicIp, showAppToast } from "../helper";
import { Constant, CURRENT_ROOM_NAME, HOST_RECEIVED_EVENTS } from '../constant';
import { Translate } from "../language";
import { prejoinDeviceCalculateFlag, SaveLog, TEMP_ROOM } from '../../customise/Utils'

const publicIP = require('public-ip');
let client;
let reducerState;
let modalState;
let modalStateV2;
let dispatch;
let timeStamp;
let isFromReconnect;
let timeoutLoader;
let isServerContentEventFirstTime = true;
let isSocketOpen = false;
let timer, hostTimer;

import {
    BUFFER_USER,
    FEATURE_CUSTOM_PAYMENT,
    FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2, FEATURE_CUSTOM_REDUX_V3, prejoinDetectDeviceEmitter, tourGuideActions
} from "../../customise/constant"
import { calculateTimeDiff, getBaseConfig, getStore, PANNING_VAR, _ValidateIPaddress } from "../../customise/Utils";
import { socketEmit } from "../../../../socket";

import {
    setAudioChannelSetting,
    setBufferChangeUser,
    setEnableWebjamModal,
    setIsBufferChange,
    setIsBufferHostReady,
    setIsDeviceListed,
    setPrejoinDeviceConnection,
    setShowConnectPopup,
    setThirdPartyModEvent,
    setUsersListArray,
    setDeviceContainerStatus,
    setPrejoinScreenDetail
} from "../../customise/redux/tool-webjam-v2/actions";

import { sendAnalytics } from "../../analytics";
import toast from "react-simple-toasts";
import { PARTICIPANT_ROLE } from "../../base/participants";
import {
    setHideWebjamConnectedMessage,
    setHostEventReceived,
    setHostHangupAutoConnect,
    setIsDeviceConnecting,
    setIsEventRequestingLoader,
    setIsWebsocketReconnecting,
    setLocalAutoConnect,
    setLocalBufferValue,
    setModeratorThirdPartyEventListened,
    setPrejoinDevicePingCalculate,
    setTourGuideType,
    setIsPreJoinAudioToMute,
    setServerConnectReHit,
    setIsDisconnectListened,
    setSoundCardsList,
    setHitFirewallApi
} from "../../customise/redux/tool-webjam-v3/actions";
import { i18next } from "../../base/i18n";
import { ct, customToast, dynamicMessageLocale } from "../../customise/constant-Utils";
export const setReducerState = (state, Dispatch) => {
    reducerState = state;
    dispatch = Dispatch;
}

var halfSpace = 0;
var fullSpace = 0;
var showTimer = 0;


export const initWebSocket = () => {
    displayConsole('--------********** initWebSocket **********-------', client);
    timeStamp = Date.now().toString() + '_web';
    dispatch(setProtocol({
        protocolId: timeStamp,
    }));

    setTimeout(() => {
        console.log("printed data", i18next.t("rta-trmc.avatar.troubleShot"))
    }, 10000)

    let publicIp;
    client = new WebSocket(Constant.App.SocketUrl, timeStamp);

    client.onopen = () => {
        isSocketOpen = true;
        modalState = toState(reducerState)[FEATURE_CUSTOM_REDUX]
        const { uniqueId, room, usersData, fcmToken, roomorIpAddress } = modalState;
        dispatch(setSocketConnectionStatus({ isSocketConnected: true }))
        console.log('--------********** onopen **********-------', CURRENT_ROOM_NAME);
        (async () => {
            // publicIp = await publicIP.default.v4();
            publicIp = await getPublicIp();
            dispatch(setPublicIp({
                publicIp: publicIp,
                //publicIp: "203.129.220.91" //"73.118.205.97", //'73.118.217.198' //'173.175.214.222' //
            }))
        })();

        // if websocket connect/disconnect and have some fluctuation then reconnect user
        if (usersData && usersData.users) {
            var { local } = getStore("features/base/participants");
            // var message = {
            //     action: {
            //         ipAddress: room,
            //         uniqueID: uniqueId,
            //         protocolId: timeStamp,
            //         fcm_id: fcmToken,
            //         jitsiId: local.id
            //     },
            //     'content': 'server-connect',
            //     isBroadcast: true,
            //     sender: 'mobile',
            // };
            let { isWebsocketReconnecting } = getStore(FEATURE_CUSTOM_REDUX_V3);
            if (isWebsocketReconnecting == 0 || isWebsocketReconnecting == 1 || isWebsocketReconnecting == 2) {
                let isWebsocketReconnectingCount = isWebsocketReconnecting + 1;
                dispatch(setIsWebsocketReconnecting(isWebsocketReconnectingCount))
                let message = {
                    action: {
                        uniqueID: usersData.uniqueId || localStorage.getItem("uniqueID"),
                        ipAddress: roomorIpAddress,
                        protocolId: localStorage.getItem("timeStamp")
                    },
                    content: 'unique_check',
                    isBroadcast: true,
                    sender: 'mobile',
                    scope: "4"

                };

                //-------------Prepare logger data -------------
                var log_data = {
                    functionName: '',
                    triggeredBy: 'system',
                    event: message.content,
                    requestData: message,
                    responseData: '',
                    userId: '',
                    boxId: message.action.uniqueID || '',
                    message: 'Emit to server'
                }
                SaveLog(log_data);
                //-------------------------------------------

                // sendData(message, 'Reconnecting...');
                sendData(message, {
                    loaderAdditionalDetail: ct("Translate.messages.deviceReconnecting"),
                });

                timer = setTimeout(function () {
                    dispatch(setUsersData(null));
                    dispatch(setDeviceContainerStatus('', 'index websocket timer'))
                    dispatch(setIsWebsocketReconnecting(3))
                    setTimeout(function () {
                        dispatch(setIsWebsocketReconnecting(0))
                    }, 10000)
                    //     dispatch(saveRoomEndValue(usersData));
                    //     // UPDATE REDUCER FOR GHOST VOICESYNC:
                    //     dispatch(setGhostVoiceSync(false));
                    //     dispatch(setMetronomeStatus({ showBox: false }));
                    //     dispatch(closeVideoCall({ closeVideo: false }));
                    if (showTimer == 0) {
                        showTimer++;
                        showAppToast(ct("Translate.messages.noResponseMixtureScreen"), Constant.App.ToastTime.HostRoomCloseTime);
                    }
                }, Constant.App.ToastTime.ReconnectingTime);

                isFromReconnect = true;
            }

        } else if (isServerContentEventFirstTime && uniqueId && roomorIpAddress) {
            isServerContentEventFirstTime = false;
            let message = {
                action: {
                    uniqueID: uniqueId,
                },
                'content': 'server-content',
                isBroadcast: true,
                sender: 'mobile',
            };

            //-------------Prepare logger data -------------
            var log_data = {
                functionName: '',
                triggeredBy: 'system',
                event: message.content,
                requestData: message,
                responseData: '',
                userId: '',
                boxId: message.action.uniqueID,
                message: 'Emit to server'
            }
            SaveLog(log_data);
            //-------------------------------------------

            sendData(message)
        }

    };

    client.onmessage = event => {
        modalState = toState(reducerState)[FEATURE_CUSTOM_REDUX]
        modalStateV2 = toState(reducerState)[FEATURE_CUSTOM_REDUX_V2]
        const {
            isBuffer,
            metronomeStatus,
            uniqueId,
            room,
            roomorIpAddress,
            fcmToken,
            publicIp,
            usersData,
            showLoader,
            clickedAutoMakeHost,
            userData,
            isUserLogin,
            conferenceJoined,
        } = modalState;

        const {
            bufferChangeUser, isDeviceListed, isBufferHostReady, thirdPartyClicked
        } = modalStateV2;

        if (event && event.data) {
            let parsedData = JSON.parse(event.data)
            // device-list :-
            if (parsedData && parsedData.action && parsedData.content == "device-list" && parsedData.action.device_arr) {
                // dispatch(setDeviceListData({
                //     deviceList: parsedData.action.device_arr ? parsedData.action.device_arr : [],
                // }));
                dispatch(saveDeviceListBase({ deviceList: parsedData.action.device_arr ? parsedData.action.device_arr : [] }))

                //-------------Prepare logger data -------------
                var log_data = {
                    functionName: '',
                    triggeredBy: 'system',
                    event: parsedData.content,
                    requestData: '',
                    responseData: parsedData,
                    userId: '',
                    boxId: parsedData.action.uniqueID || '',
                    message: 'Listen to client'
                }
                SaveLog(log_data);
                //-------------------------------------------

                // if (isUserLogin) {
                //     dispatch(setEnableWebjamModal(true));
                // }
                let { isEventRequestingLoader } = getStore(FEATURE_CUSTOM_REDUX_V3);
                if (isEventRequestingLoader == '') {
                    hideLoader("device-list");
                }
            }
            //UNIQUE ID:-
            if (parsedData && parsedData.content && parsedData.content == "unique_check") {


                if (parsedData &&
                    parsedData.action &&
                    ((parsedData.action.uniqueID == uniqueId && parsedData.action.protocolId == timeStamp)
                        || parsedData.action.uniqueID == localStorage.getItem("uniqueID") && parsedData.action.protocolId == localStorage.getItem("timeStamp"))
                ) {

                    if (parsedData && parsedData.action && parsedData.action.check) {

                        //-------------Prepare logger data -------------
                        var log_data = {
                            functionName: '',
                            triggeredBy: 'system',
                            event: parsedData.content,
                            requestData: '',
                            responseData: parsedData,
                            userId: '',
                            boxId: (parsedData.action && parsedData.action.uniqueID) ? parsedData.action.uniqueID : '',
                            message: 'Listen to client'
                        }
                        SaveLog(log_data);
                        //-------------------------------------------

                        localStorage.setItem("uniqueID", uniqueId);
                        localStorage.removeItem("timeStamp");
                        localStorage.setItem("timeStamp", timeStamp);
                        const { isModeratorThirdPartyListen } = getStore(FEATURE_CUSTOM_REDUX_V3);
                        let noChangedRoomName = getBaseConfig('noChangedRoomName')
                        let roomorIpAddressNew = roomorIpAddress

                        let store_v2 = getStore(FEATURE_CUSTOM_REDUX_V2);
                        let currentRoom = CURRENT_ROOM_NAME;

                        if (!conferenceJoined || getBaseConfig("showPreJoiningInConference")) {
                            if (store_v2.prejoinScreenDetail.isSet) {
                                if (store_v2.prejoinScreenDetail.roomname != "") {
                                    roomorIpAddressNew = store_v2.prejoinScreenDetail.roomname;
                                    currentRoom = '';
                                }
                            }
                        }

                        if (noChangedRoomName == true) {
                            if (roomorIpAddressNew) {
                                if (_ValidateIPaddress(roomorIpAddressNew)) {
                                    if (roomorIpAddressNew.includes('_')) {
                                        roomorIpAddressNew = roomorIpAddressNew.replace("_", ":")
                                    }
                                }
                            }
                        }

                        if ((localStorage.getItem('makeHostConnect') == 'true' || isModeratorThirdPartyListen
                            // localStorage.getItem('thirdPartyMakeHostConnect') == 'true'
                        ) && modalStateV2.isBufferChange == false) {
                            var { local } = getStore("features/base/participants");
                            if (_ValidateIPaddress(roomorIpAddress)) {
                                var message = {
                                    action: {
                                        ipAddress: roomorIpAddressNew,
                                        uniqueID: uniqueId ? uniqueId : localStorage.getItem("uniqueID"),
                                        protocolId: timeStamp,
                                        fcm_id: fcmToken,
                                        jitsiId: local.id,
                                        visibleRoom: currentRoom,
                                        scope: 1
                                    },
                                    'content': 'server-connect',
                                    isBroadcast: true,
                                    sender: 'mobile',
                                };
                            } else {
                                var message = {
                                    action: {
                                        ipAddress: roomorIpAddressNew,
                                        uniqueID: uniqueId ? uniqueId : localStorage.getItem("uniqueID"),
                                        protocolId: timeStamp,
                                        fcm_id: fcmToken,
                                        makeHost: true,
                                        jitsiId: local.id,
                                        visibleRoom: currentRoom,
                                        scope: 2
                                    },
                                    'content': 'server-connect',
                                    isBroadcast: true,
                                    sender: 'mobile',
                                };
                            }

                            //-------------Prepare logger data -------------
                            var log_data = {
                                functionName: '',
                                triggeredBy: 'system',
                                event: message.content,
                                requestData: message,
                                responseData: '',
                                userId: '',
                                boxId: message.action.uniqueID,
                                message: 'Emit to server'
                            }
                            SaveLog(log_data);
                            //-------------------------------------------

                            dispatch(setclickMakeHost(true));
                            dispatch(showApiLoader({
                                loaderAdditionalDetail: ct("Translate.messages.deviceConnecting"),
                                type: 444
                            }));

                            client.send(JSON.stringify(message));
                            let _userName = getStore('features/base/participants').local?.name;
                            if (!_userName) {
                                _userName = "user";
                            }
                            var _message = {
                                action: {
                                    firstname: _userName,
                                    lastname: '',
                                    uniqueID: message.action.uniqueID,
                                },
                                content: 'set-name',
                                isBroadcast: true,
                                sender: 'mobile',
                            };

                            //-------------Prepare logger data -------------
                            var log_data = {
                                functionName: '',
                                triggeredBy: 'system',
                                event: message.content,
                                requestData: message,
                                responseData: '',
                                userId: '',
                                boxId: message.action.uniqueID,
                                message: 'Emit to server'
                            }
                            SaveLog(log_data);
                            //-------------------------------------------

                            client.send(JSON.stringify(_message));
                        } else {
                            var { local } = getStore("features/base/participants");
                            dispatch(setData({
                                uniqueId: localStorage.getItem("uniqueID"),
                                room: roomorIpAddress
                            }));
                            var message = {
                                action: {
                                    ipAddress: roomorIpAddressNew,
                                    uniqueID: uniqueId ? uniqueId : localStorage.getItem("uniqueID"),
                                    protocolId: timeStamp,
                                    fcm_id: fcmToken,
                                    jitsiId: local.id,
                                    visibleRoom: currentRoom,
                                    scope: 3
                                },
                                'content': 'server-connect',
                                isBroadcast: true,
                                sender: 'mobile',
                            };
                            let _storage = getStore(FEATURE_CUSTOM_REDUX_V2)

                            // if (parsedData.action.hasOwnProperty("hostBuf")) {
                            if (_storage.bufferChangeUser || _storage.isBufferChange) {
                                message.action.hostBuf = true;
                            }
                            // }

                            // don't show loader when checking device status/connectivity on prejoin screen
                            if (conferenceJoined == true) {
                                // if (window.isPreJoinChecking == undefined) {
                                dispatch(showApiLoader({
                                    loaderAdditionalDetail: ct("Translate.messages.deviceConnecting"),
                                    type: 555
                                }));
                            }


                            //-------------Prepare logger data -------------
                            var log_data = {
                                functionName: '',
                                triggeredBy: 'system',
                                event: message.content,
                                requestData: '',
                                responseData: parsedData,
                                userId: '',
                                boxId: message.action.uniqueID || '',
                                message: 'Emit to server'
                            }
                            SaveLog(log_data);
                            //-------------------------------------------

                            client.send(JSON.stringify(message));

                            let _userName = getStore('features/base/participants').local?.name;
                            if (!_userName) {
                                _userName = "user";
                            }
                            var _message = {
                                action: {
                                    firstname: _userName,
                                    lastname: '',
                                    uniqueID: message.action.uniqueID,
                                },
                                content: 'set-name',
                                isBroadcast: true,
                                sender: 'mobile',
                            };

                            //-------------Prepare logger data -------------
                            var log_data = {
                                functionName: '',
                                triggeredBy: 'system',
                                event: message.content,
                                requestData: message,
                                responseData: '',
                                userId: '',
                                boxId: message.action.uniqueID,
                                message: 'Emit to server'
                            }
                            SaveLog(log_data);
                            //-------------------------------------------

                            client.send(JSON.stringify(_message));
                        }
                    } else {
                        // Don't do anything
                        // if (usersData) {
                        //     hideLoader("unique_check");
                        //     dispatch(setUserConnectionStatus({
                        //         isConnected: false,
                        //         isHelpModal: true,
                        //     }));
                        //     dispatch(setUsersData(null));
                        //     // UPDATE REDUCER FOR GHOST VOICESYNC:
                        //     dispatch(setGhostVoiceSync(false));
                        //     showAppToast(ct("Translate.messages.webJamNotConnected"), Constant.App.ToastTime.ReconnectingTime);
                        // } else {
                        // }
                    }
                }
            }

            // Server Connect:-
            if (parsedData && parsedData.content && parsedData.content == "server-connect") {
                if (parsedData &&
                    (parsedData.action.uniqueID == uniqueId || parsedData.action.uniqueID == localStorage.getItem("uniqueID")) &&
                    parsedData.action.protocolID == timeStamp) {
                    if (parsedData && parsedData.action && parsedData.action.users && parsedData.action.users.length > 0) {
                        //-------------Prepare logger data -------------
                        var log_data = {
                            functionName: '',
                            triggeredBy: 'system',
                            event: parsedData.content,
                            requestData: '',
                            responseData: parsedData,
                            userId: '',
                            boxId: (parsedData.action && parsedData.action.uniqueID) ? parsedData.action.uniqueID : '',
                            message: 'Listen to client'
                        }
                        SaveLog(log_data);
                        //-------------------------------------------

                        // START: To check if we are connected to correct room or not
                        let startServerConnectProcess = true;
                        let protocolId = getStore(FEATURE_CUSTOM_REDUX).protocolId
                        let connectingRoom = parsedData.action.actualRoom;
                        let connectedRoom = roomorIpAddress;

                        if (_ValidateIPaddress(connectingRoom)) {
                            if (connectingRoom.includes("_")) {
                                connectingRoom = connectingRoom.replace("_", ":")
                            }
                        }

                        if (_ValidateIPaddress(connectedRoom)) {
                            if (connectedRoom.includes("_")) {
                                connectedRoom = connectedRoom.replace("_", ":")
                            }
                        }

                        if (connectingRoom && connectingRoom != '' && connectingRoom != connectedRoom) {
                            dispatch(setEnableWebjamModal(false));
                            dispatch(setServerConnectReHit(true));
                            startServerConnectProcess = false;
                            dispatch(setRoomorIpAddress(parsedData.action.actualRoom, 'server-connect-re-hit'));
                            dispatch(showApiLoader({
                                loaderAdditionalDetail: ct("Translate.messages.serverConnectRehitLoader"),
                            }));
                            const data = {
                                action: {
                                    uniqueID: uniqueId,
                                    ipAddress: roomorIpAddress,
                                    protocolId: protocolId,
                                },
                                content: 'unpair-device',
                                isBroadcast: true,
                                sender: 'mobile',
                                scope: "server-connect-unpair"
                            }
                            //-------------Prepare logger data -------------
                            var log_data = {
                                functionName: '',
                                triggeredBy: 'system',
                                event: data.content,
                                requestData: data,
                                responseData: '',
                                userId: '',
                                boxId: data.action.uniqueID,
                                message: 'Emit to server'
                            }
                            SaveLog(log_data);
                            //-------------------------------------------
                            sendData(data);

                            setTimeout(() => {
                                const message = {
                                    action: {
                                        uniqueID: uniqueId,
                                        ipAddress: connectingRoom,
                                        protocolId,
                                    },
                                    content: 'unique_check',
                                    isBroadcast: true,
                                    sender: 'mobile',
                                    scope: 'server-connect-pair-to-different-room'
                                };
                                //-------------Prepare logger data -------------
                                var log_data = {
                                    functionName: '',
                                    triggeredBy: 'system',
                                    event: message.content,
                                    requestData: message,
                                    responseData: '',
                                    userId: '',
                                    boxId: message.action.uniqueID,
                                    message: 'Emit to server'
                                }
                                SaveLog(log_data);
                                //-------------------------------------------
                                sendData(message);
                            }, 30000)
                        } else {
                            startServerConnectProcess = true;
                            dispatch(setServerConnectReHit(false));
                        }
                        // END: To check if we are connected to correct room or not

                        if (startServerConnectProcess) {
                            dispatch(setIsEventRequestingLoader(''))
                            dispatch(setIsDeviceConnecting(false))
                            let mycounter = 0;
                            // Hit socket once device connected 
                            let storeV1 = getStore(FEATURE_CUSTOM_REDUX);
                            if (parsedData.action?.isHost) {
                                if ((storeV1.clickedAutoMakeHost && sessionStorage.getItem("uniqueID") == uniqueId)
                                    || sessionStorage.getItem("isUserMakeHost")) {
                                    sessionStorage.setItem("uniqueID", localStorage.getItem("uniqueID"));
                                    sessionStorage.removeItem("isUserMakeHost")
                                }
                            }
                            dispatch(setData({
                                uniqueId: localStorage.getItem("uniqueID"),
                                room: roomorIpAddress
                            }));

                            if (timer) {
                                clearTimeout(timer);
                            }

                            if (hostTimer) {
                                clearTimeout(hostTimer);
                            }

                            localStorage.removeItem('makeHostConnect');
                            localStorage.removeItem('thirdPartyMakeHostConnect');
                            localStorage.removeItem("newRoomHosted");

                            dispatch(setUserConnectionStatus({
                                isConnected: true,
                            }));

                            dispatch(setUsersData({
                                ...parsedData.action,
                                users: parsedData.action.users,
                                uniqueId,
                            }));

                            dispatch(setShowHideStatusWebJamMenu({
                                isFromWebJam: true,
                            }));

                            dispatch(setMetronomeStatus({
                                showBox: true
                            }));

                            setTimeout(async () => {
                                const disconnectBtnMsg = await dynamicMessageLocale(parsedData?.action?.disconnectBtnMsg || "");
                                //Save Data for Disconnecting Socket:-
                                dispatch(saveHostResponse({
                                    ...parsedData.action,
                                    room,
                                    uniqueId,
                                    disconnectBtnMsg
                                }));
                            });


                            dispatch(setData({
                                uniqueId: uniqueId,
                                room: room
                            }));

                            localStorage.setItem('Save_Response', JSON.stringify({
                                uniqueId: uniqueId,
                                room: room
                            }));

                            if (!isFromReconnect) {
                                dispatch(setJoinRoomModalStatus({
                                    joinRoomModalStatus: false,
                                }));
                                dispatch(setVideoScreenStatus({
                                    videoScreenStatus: true,
                                }));
                            } else {
                                isFromReconnect = false;
                            }

                            hideLoader("server-connect");
                            localStorage.removeItem("newRoomHosted");

                            dispatch(setAudioMuted(true));
                            //dispatch(setclickMakeHost(false)); //TO MANAGE MAKE HOST EFFECT ON DEVICE POPUP SHOW/HIDE

                            let userName = getStore('features/base/participants').local?.name;
                            if (!userName) {
                                //userName = "RTA User";
                                // userName = "user";na
                                userName = getBaseConfig("userName");
                            }
                            var message = {
                                action: {
                                    firstname: userName,
                                    lastname: '',
                                    uniqueID: uniqueId,
                                },
                                content: 'set-name',
                                isBroadcast: true,
                                sender: 'mobile',
                            };

                            //-------------Prepare logger data -------------
                            var log_data = {
                                functionName: '',
                                triggeredBy: 'system',
                                event: message.content,
                                requestData: message,
                                responseData: '',
                                userId: '',
                                boxId: message.action.uniqueID,
                                message: 'Emit to server'
                            }
                            SaveLog(log_data);
                            //-------------------------------------------

                            sendData(message);

                            if (mycounter == 0) {
                                let webjamConnectMessage = getBaseConfig("webJamConnected")

                                // don't show loader when checking device status/connectivity on prejoin screen
                                if (window.isPreJoinChecking == undefined) {

                                    dispatch(setPrejoinScreenDetail({
                                        isSet: false,
                                        roomname: "",
                                        uniqueId: "",
                                        scope: "reconnected"
                                    }))

                                }

                                let { hideWebjamConnectedMessage, showDevicePreConnection } = getStore(FEATURE_CUSTOM_REDUX_V3);
                                if (conferenceJoined == true && !hideWebjamConnectedMessage && !showDevicePreConnection) {
                                    dispatch(showToastPopup({ toastModal: true, modalText: webjamConnectMessage }));
                                    let tourGuideType = getStore(FEATURE_CUSTOM_REDUX_V3).tourGuideType;
                                    if (tourGuideType == tourGuideActions.USER_HAS_PREMIUM_SUBSCRIPTION) {
                                        dispatch(setTourGuideType(tourGuideActions.USER_RECONNECTED))
                                    }
                                    dispatch(setHideWebjamConnectedMessage(false))
                                }
                            }
                            mycounter = mycounter + 1;
                            setTimeout(() => {
                                dispatch(showToastPopup({ toastModal: false, modalText: '' }));
                            }, 20000);
                        }
                    } else {
                        if (usersData) {
                            dispatch(setUserConnectionStatus({
                                isConnected: false,
                                isHelpModal: true,
                            }));
                            dispatch(setUsersData(null));
                            // UPDATE REDUCER FOR GHOST VOICESYNC:
                            dispatch(setGhostVoiceSync(false));
                            hideLoader("server-connect");
                            showAppToast(ct("Translate.messages.webJamNotConnected"), Constant.App.ToastTime.ReconnectingTime);
                        } else {
                            displayConsole("server-connect: no need of disconnecting device");
                        }
                    }
                }
            }

            //show latency 
            if (parsedData && parsedData.action && parsedData.content == "latency") {
                if (parsedData && parsedData.action &&
                    parsedData.action.uniqueID == uniqueId &&
                    parsedData.action.protocolID == timeStamp) {
                    hideLoader('set-latency'); //Replaced AA
                    const data = {
                        delay: parsedData.action.delay,
                        pingTime: parsedData.action.pingTime,
                        upstream: parsedData.action.upstream,
                        processingDelay: parsedData.action.processingDelay,
                        jitterBuffer: parsedData.action.jitterBuffer,
                        showdrop: parsedData.action.showdrop,
                        dropCount: parsedData.action.dropCount
                    }
                    dispatch(setLatencyStatus(data));
                }
            }

            //host exist:-
            if (parsedData && parsedData.action && parsedData.content == "host-exist") {
                if (parsedData && parsedData.action.uniqueID == uniqueId) {
                    if (parsedData && parsedData.action && parsedData.action.errMsg) {
                        const obj = {
                            joinRoomModalStatus: false,
                        }
                        dispatch(setJoinRoomModalStatus(obj));
                        hideLoader("host-exist");
                        // showAppToast(parsedData.action.errMsg, Constant.App.ToastTime.HostExistTime);
                        // START : Hit firewall API 
                        let selfRoomUrl = !_ValidateIPaddress(CURRENT_ROOM_NAME)
                        let selfRoomBox = !_ValidateIPaddress(roomorIpAddress)
                        if (selfRoomUrl && selfRoomBox) {
                            console.log("Firewall flow will work =>")
                            dispatch(setHitFirewallApi(true));
                        } else {
                            dispatch(showToastPopup({ toastModal: true, modalText: ct("Translate.messages.disableFirewall") }));
                            setTimeout(() => {
                                dispatch(showToastPopup({ toastModal: false, modalText: '' }));
                            }, 5000);
                        }
                        // END : Hit firewall API 
                    }
                }
            }

            //stem recording/individual track recording, if device storage is 50% in between the recording, device will notify and popup will apear to stop or continue.
            if (parsedData && parsedData.action && parsedData.content == "space-getting-full") {
                if (parsedData.action.deviceId == uniqueId) {
                    // if (halfSpace == 0) {
                    dispatch(showToastPopup({
                        toastModal: true,
                        modalText: ct("Translate.messages.spaceIsHalf"),
                        toastSubmitFunction: "continueRecording",
                        toastCancelFunction: "stopRecording"
                    }));
                    // }
                    // halfSpace++;
                }
            }

            //stem recording/individual track recording, if device storage is 75% in between the recording, device will notify and recording is stopped by backend.
            if (parsedData && parsedData.action && parsedData.content == "space-is-full") {

                if (parsedData.action.deviceId == uniqueId) {

                    //-------------Prepare logger data -------------
                    var log_data = {
                        functionName: '',
                        triggeredBy: 'system',
                        event: parsedData.content,
                        requestData: parsedData,
                        responseData: '',
                        userId: '',
                        boxId: (parsedData.action && parsedData.action.uniqueID) ? parsedData.action.uniqueID : '',
                        message: 'Listen to client'
                    }
                    SaveLog(log_data);
                    //-------------------------------------------

                    // if (fullSpace == 0) {
                    dispatch(showToastPopup({
                        toastModal: true,
                        modalText: ct("Translate.messages.spaceIsFull"),
                        toastAutoSubmit: "autoStopRecording"
                    }));
                    // }
                    // fullSpace++;
                }
            }

            if (parsedData && parsedData.action && (parsedData.content == "app-configuration" || parsedData.content == "moderator-control")) {
                const { isEventRequestingLoader } = getStore(FEATURE_CUSTOM_REDUX_V3);

                if (parsedData && parsedData.action &&
                    parsedData.action.users &&
                    parsedData.action.users.length > 0 &&
                    isEventRequestingLoader == '') {
                    const { audioChannelConfig, delayLocalChange } = getStore(FEATURE_CUSTOM_REDUX_V2);
                    // if (parsedData.action.hostedRoom == roomorIpAddress || parsedData.action.hostAddress == roomorIpAddress) {
                    if (parsedData.action.uniqueID == uniqueId && delayLocalChange == false) {
                        if (parsedData.content == "moderator-control") {
                            //-------------Prepare logger data -------------
                            var log_data = {
                                functionName: '',
                                triggeredBy: 'system',
                                event: parsedData.content,
                                requestData: parsedData,
                                responseData: '',
                                userId: '',
                                boxId: (parsedData.action && parsedData.action.uniqueID) ? parsedData.action.uniqueID : '',
                                message: 'Listen to client'
                            }
                            SaveLog(log_data);
                            //-------------------------------------------
                        }

                        dispatch(setAudioChannelSetting(parsedData.action.audioChannel, { isLocal: true }));
                        var { delayPanning } = getStore(FEATURE_CUSTOM_REDUX);

                        let fxModal = document.getElementById("show-fx-modal");
                        if (fxModal === null) {
                            if (parsedData.action.audioChannel == 0) {
                                dispatch(setDelayPanning(PANNING_VAR.NO_PANNING));
                            } else if (parsedData.action.audioChannel == 1) {
                                if (parsedData.action.uniqueID == uniqueId && delayPanning == PANNING_VAR.DELAY_PANNING) {
                                    // dispatch(setDelayPanning(PANNING_VAR.VOLUME_PANNING, { selfChange: true }));
                                } else {
                                    dispatch(setDelayPanning(PANNING_VAR.VOLUME_PANNING));
                                }
                            } else if (parsedData.action.audioChannel == 2) {
                                if (delayPanning != PANNING_VAR.DELAY_PANNING) { // If panning is delay panning and audio channel is mono-in/stereo-out, but user change audio mode stereo it should not be change
                                    dispatch(setDelayPanning(PANNING_VAR.VOLUME_PANNING));
                                }
                            }
                        }

                        // CUSTOM
                        if (parsedData?.action?.panningName) {
                            dispatch(setDelayPanning(parsedData?.action?.panningName));
                        }
                        // END
                    }
                }
            }

            // App configuration:-
            if (parsedData && parsedData.action && (parsedData.content == "app-configuration" || parsedData.content == "moderator-control")) {
                const { isEventRequestingLoader } = getStore(FEATURE_CUSTOM_REDUX_V3);
                if (parsedData &&
                    parsedData.action.uniqueID == uniqueId &&
                    parsedData.action.protocolID == timeStamp &&
                    isEventRequestingLoader == '') {
                    if (parsedData.content == "moderator-control") {
                        //-------------Prepare logger data -------------
                        var log_data = {
                            functionName: '',
                            triggeredBy: 'system',
                            event: parsedData.content,
                            requestData: parsedData,
                            responseData: '',
                            userId: '',
                            boxId: (parsedData.action && parsedData.action.uniqueID) ? parsedData.action.uniqueID : '',
                            message: 'Listen to client'
                        }
                        SaveLog(log_data);
                        //-------------------------------------------
                    }

                    if (parsedData && parsedData.action &&
                        parsedData.action.users &&
                        parsedData.action.users.length > 0 &&
                        isEventRequestingLoader == '') {
                        // hideLoader("app-configuration");
                        setTimeout(function () {
                            hideLoader("app-configuration");
                        }, 2000)
                        var data = {
                            ...parsedData.action,
                            uniqueId,
                            temp: parsedData.action.isMuteMySelf,
                        }

                        dispatch(setUsersData(data));
                        let allData = getStore(FEATURE_CUSTOM_REDUX);
                        let prevData = allData.prevPanning;
                        if (prevData.length) {
                            let m = prevData[prevData.length - 1];
                            if (m != parsedData.action.audioChannel) {
                                prevData.push(parsedData.action.audioChannel)
                            }
                        } else {
                            prevData = [];
                            prevData.push(parsedData.action.audioChannel)
                        }

                        if (getBaseConfig("showSoftwareVersion") &&
                            parsedData.action.hasOwnProperty("deviceType") &&
                            parsedData.action.deviceType == 1) {
                            const { currentSoundCard, soundCards } = getStore(FEATURE_CUSTOM_REDUX_V3)
                            let prevCurrentSoundCard = currentSoundCard;
                            let prevSoundCards = soundCards;
                            let newCurrentSoundCard = parsedData.action.currentSoundCard;
                            let newSoundCards = parsedData.action.soundCards;

                            if ((prevCurrentSoundCard != newCurrentSoundCard) || (!prevSoundCards.length) || (prevSoundCards?.length != newSoundCards?.length)) {
                                dispatch(setSoundCardsList(newCurrentSoundCard, newSoundCards))
                            }
                        }


                        dispatch(setPrevPanning(prevData));
                        if (parsedData.content == "moderator-control" && parsedData.action.moderatorMsg) {
                            // showAppToast(parsedData.action.moderatorMsg, Constant.App.ToastTime.DelayTime)

                            setTimeout(async () => {
                                let message = await dynamicMessageLocale(parsedData.action.moderatorMsg)
                                showAppToast(message, Constant.App.ToastTime.DelayTime)
                            })
                        }
                    }
                }
            }

            // Set Profile User name:-
            if (parsedData && parsedData.action && parsedData.content == "set-name") {

                if (parsedData &&
                    parsedData.action.uniqueID == uniqueId &&
                    parsedData.action.protocolID == timeStamp) {

                    //-------------Prepare logger data -------------
                    var log_data = {
                        functionName: '',
                        triggeredBy: 'system',
                        event: parsedData.content,
                        requestData: parsedData,
                        responseData: '',
                        userId: '',
                        boxId: (parsedData.action && parsedData.action.uniqueID) ? parsedData.action.uniqueID : '',
                        message: 'Listen to client'
                    }
                    SaveLog(log_data);
                    //-------------------------------------------

                    if (parsedData && parsedData.action &&
                        parsedData.action.users &&
                        parsedData.action.users.length > 0) {
                        hideLoader("set-name");
                        const data = {
                            ...parsedData.action,
                            uniqueId,
                            temp: parsedData.action.isMuteMySelf,
                        }
                        dispatch(setUsersData(data));
                    }
                }
            }

            // Server Disconnect :-
            if (parsedData && parsedData.action && parsedData.content == "server-disconnect") {
                if (parsedData &&
                    parsedData.action.uniqueID == uniqueId &&
                    parsedData.action.protocolID == timeStamp
                ) {

                    //-------------Prepare logger data -------------
                    var log_data = {
                        functionName: '',
                        triggeredBy: 'system',
                        event: parsedData.content,
                        requestData: parsedData,
                        responseData: '',
                        userId: '',
                        boxId: (parsedData.action && parsedData.action.uniqueID) ? parsedData.action.uniqueID : '',
                        message: 'Listen to client'
                    }
                    SaveLog(log_data);
                    //-------------------------------------------

                    hideLoader("server-disconnect");
                    dispatch(setShowHideStatusWebJamMenu({
                        isFromWebJam: false,
                    }));
                    dispatch(setUserConnectionStatus({ isConnected: false }));
                    dispatch(setUsersData(null));
                    // UPDATE REDUCER FOR GHOST VOICESYNC:
                    dispatch(setGhostVoiceSync(false));
                    dispatch(setMetronomeStatus({ showBox: false }));
                    showAppToast(ct("Translate.messages.disConnected"), Constant.App.ToastTime.DelayTime);
                }
            }

            // Device Disconnect :-
            if (parsedData &&
                parsedData.action &&
                parsedData.content == "device-disconnect" &&
                parsedData.action.uniqueID == uniqueId &&
                parsedData.action.protocolID == timeStamp
            ) {

                //-------------Prepare logger data -------------
                var log_data = {
                    functionName: '',
                    triggeredBy: 'system',
                    event: parsedData.content,
                    requestData: parsedData,
                    responseData: '',
                    userId: '',
                    boxId: (parsedData.action && parsedData.action.uniqueID) ? parsedData.action.uniqueID : '',
                    message: 'Listen to client'
                }
                SaveLog(log_data);
                //-------------------------------------------

                // const data = {
                //     ...parsedData.action
                // }
                // dispatch(saveRoomEndValue(data));
                var { isBufferChange } = getStore(FEATURE_CUSTOM_REDUX_V2)
                setTimeout(function () {
                    dispatch(setAudioMuted(true));
                    dispatch(setIsPreJoinAudioToMute(true));
                }, 200)
                if (isBuffer) {
                    //FOR BUFFER VALUE AUTOCONNECTION STEP 1
                    dispatch(setUsersData(null));
                    // UPDATE REDUCER FOR GHOST VOICESYNC:
                    dispatch(setGhostVoiceSync(false));
                    //hideLoader("device disconnect buffer");
                    showAppToast(ct("Translate.messages.disConnected"), Constant.App.ToastTime.DelayTime);
                    const bufferData = {
                        isBuffer: false
                    }
                    dispatch(setShowConnectPopup('bufferParticipant'));
                    dispatch(setBufferValue(bufferData));
                    dispatch(setLocalBufferValue(true))
                    // localStorage.setItem("bufferValue", true);
                } else {
                    if (isBufferChange == false) { // when host change its buffer device disconnecting and sending event of device disconnect, set this flag to by pass disconnect from room

                        // setTimeout(function () {
                        //     const data = {
                        //         ...parsedData.action
                        //     }
                        //     dispatch(saveRoomEndValue(data));
                        // }, 10000)
                        //showAppToast(parsedData.action.msg, Constant.App.ToastTime.DelayTime);

                        var store_v3 = getStore(FEATURE_CUSTOM_REDUX_V3)

                        let hasErrorFlag = false;
                        if (store_v3.boxDeviceErrorInfo.error.length) {
                            hasErrorFlag = true
                        }

                        if (conferenceJoined) {
                            if (!hasErrorFlag && !store_v3.showDevicePreConnection) {
                                dispatch(showToastPopup({ toastModal: true, modalText: ct("Translate.internet.internetDisconnectMsg") }));
                            }
                        }
                        let protocolId = getStore(FEATURE_CUSTOM_REDUX).protocolId
                        const data = {
                            action: {
                                uniqueID: uniqueId,
                                ipAddress: roomorIpAddress,
                                protocolId,
                            },
                            content: 'unpair-device',
                            isBroadcast: true,
                            sender: 'mobile'
                        }

                        //-------------Prepare logger data -------------
                        var log_data = {
                            functionName: '',
                            triggeredBy: 'system',
                            event: data.content,
                            requestData: data,
                            responseData: '',
                            userId: '',
                            boxId: data.action.uniqueID,
                            message: 'Emit to server'
                        }
                        SaveLog(log_data);
                        //-------------------------------------------

                        sendData(data);
                        dispatch(setDeviceContainerStatus("closeDeviceDisconnect", 'device-disconnect'));
                        setTimeout(() => {
                            dispatch(setDeviceContainerStatus('', 'reset-flag'));
                        }, 5000);

                        if (hasErrorFlag) {
                            dispatch(hideApiLoader())
                        }

                        setTimeout(() => {
                            dispatch(hideApiLoader())
                        }, 20000);

                        var storeB = getStore(FEATURE_CUSTOM_REDUX_V2);
                        if (storeB.prejoinScreenDetail.isSet) {
                            dispatch(setPrejoinScreenDetail({
                                isSet: false,
                                roomname: "",
                                uniqueId: "",
                                scope: "device connection lost"
                            }));
                        }
                        dispatch(setUsersListArray([]));
                        // dispatch(saveRoomEndValue(null));

                        dispatch(setData({
                            uniqueId: '',
                            room: ''
                        }));
                        localStorage.removeItem("uniqueID");
                        // new added
                        dispatch(setUsersData(null));
                        if (!hasErrorFlag) {
                            setTimeout(function () {
                                dispatch(showToastPopup({ toastModal: false, modalText: '' }));
                            }, 10000)
                        }

                    }
                }
            }

            // Room  Ended :-
            if (parsedData &&
                parsedData.action &&
                parsedData.content == "room-ended" &&
                parsedData.action.uniqueID == uniqueId &&
                parsedData.action.protocolID == timeStamp
            ) {
                const data = {
                    ...parsedData.action
                }
                // dispatch(saveRoomEndValue(data));
                if (isBuffer) {
                    showAppToast(ct("Translate.messages.disConnected"), Constant.App.ToastTime.DelayTime);
                    const bufferData = {
                        isBuffer: false
                    }
                    dispatch(setBufferValue(bufferData));
                } else {
                    const { hostHangupEventReceived, showDevicePreConnection } = getStore(FEATURE_CUSTOM_REDUX_V3);
                    if (hostHangupEventReceived) {
                        dispatch(setDeviceContainerStatus("hostHangupEventReceived", 'room-ended'))
                    } else {
                        if (!showDevicePreConnection) {
                            dispatch(showToastPopup({ toastModal: true, modalText: ct("Translate.internet.tempInternetDisconnectMsg") }));
                        }
                        let protocolId = getStore(FEATURE_CUSTOM_REDUX).protocolId
                        const data = {
                            action: {
                                uniqueID: uniqueId,
                                ipAddress: roomorIpAddress,
                                protocolId,
                            },
                            content: 'unpair-device',
                            isBroadcast: true,
                            sender: 'mobile'
                        }

                        //-------------Prepare logger data -------------
                        var log_data = {
                            functionName: '',
                            triggeredBy: 'system',
                            event: data.content,
                            requestData: data,
                            responseData: '',
                            userId: '',
                            boxId: data.action.uniqueID,
                            message: 'Emit to server'
                        }
                        SaveLog(log_data);
                        //-------------------------------------------

                        sendData(data);
                        dispatch(setDeviceContainerStatus("closeRoomEnded", 'room-ended'))
                        // dispatch(saveRoomEndValue(null));
                        dispatch(setUsersListArray([]));
                        setTimeout(function () {
                            dispatch(showToastPopup({ toastModal: false, modalText: '' }));
                        }, 10000)

                        // setTimeout(function () {
                        //     window.location.href = window.location.origin;
                        // }, 10000)
                    }
                }
            }

            // Mute My self:-
            if (parsedData && parsedData.action && parsedData.content == "mute-myself") {
                if (parsedData &&
                    parsedData.action.uniqueID == uniqueId &&
                    parsedData.action.protocolID == timeStamp) {

                    //-------------Prepare logger data -------------
                    var log_data = {
                        functionName: '',
                        triggeredBy: 'system',
                        event: parsedData.content,
                        requestData: parsedData,
                        responseData: '',
                        userId: '',
                        boxId: (parsedData.action && parsedData.action.uniqueID) ? parsedData.action.uniqueID : '',
                        message: 'Listen to client'
                    }
                    SaveLog(log_data);
                    //-------------------------------------------
                    hideLoader("mute-myself");
                    if (parsedData && parsedData.action) {
                        // client.close()
                        const data = {
                            ...parsedData.action,
                            uniqueId,
                            temp: parsedData.action.isMuteMySelf,
                        }
                        dispatch(setUsersData(data));
                        sendAnalytics({
                            action: 'mute-myself',
                            source: "webjam",
                            category: "mute myself"
                        });
                    }
                }
            }

            // Setting To App :-
            if (parsedData && parsedData.action && parsedData.content == "setting-to-app") {
                if (parsedData &&
                    parsedData.action.uniqueID == uniqueId &&
                    parsedData.action.protocolID == timeStamp) {

                    //-------------Prepare logger data -------------
                    var log_data = {
                        functionName: '',
                        triggeredBy: 'system',
                        event: parsedData.content,
                        requestData: parsedData,
                        responseData: '',
                        userId: '',
                        boxId: (parsedData.action && parsedData.action.uniqueID) ? parsedData.action.uniqueID : '',
                        message: 'Listen to client'
                    }
                    SaveLog(log_data);
                    //-------------------------------------------

                    hideLoader("setting-to-app");
                    if (parsedData && parsedData.action && parsedData.action.users && parsedData.action.users.length > 0) {
                        const data = {
                            ...parsedData.action,
                            uniqueId,
                            temp: parsedData.action.isMuteMySelf,
                        }
                        dispatch(setUsersData(data));
                    }
                    if (parsedData && parsedData.action && parsedData.action.users && parsedData.action.users.length == 0) {
                        hideLoader("server-disconnect");
                        dispatch(setShowHideStatusWebJamMenu({
                            isFromWebJam: false,
                        }));
                        dispatch(setUserConnectionStatus({ isConnected: false }));
                        dispatch(setUsersData(null));
                        // UPDATE REDUCER FOR GHOST VOICESYNC:
                        dispatch(setGhostVoiceSync(false));
                        dispatch(setMetronomeStatus({ showBox: false }));
                    }
                }
            }

            // server-content :-
            if (parsedData && parsedData.action && parsedData.content == "server-content") {
                if (parsedData &&
                    parsedData.action &&
                    parsedData.action.uniqueID == uniqueId &&
                    parsedData.action.isHost) {

                    //-------------Prepare logger data -------------
                    var log_data = {
                        functionName: '',
                        triggeredBy: 'system',
                        event: parsedData.content,
                        requestData: parsedData,
                        responseData: '',
                        userId: '',
                        boxId: (parsedData.action && parsedData.action.uniqueID) ? parsedData.action.uniqueID : '',
                        message: 'Listen to client'
                    }
                    SaveLog(log_data);
                    //-------------------------------------------

                    const data = {
                        ...parsedData.action,
                    }
                    hideLoader("server-content");
                    dispatch(setUsersData(data));
                } else if (parsedData &&
                    parsedData.action &&
                    parsedData.action.uniqueID == uniqueId &&
                    !parsedData.action.isHost) {
                    hideLoader("server-content");
                    dispatch(setUsersData(null));
                    // UPDATE REDUCER FOR GHOST VOICESYNC:
                    dispatch(setGhostVoiceSync(false));
                }
            }

            if (parsedData &&
                parsedData.action &&
                parsedData.content == "devices"
            ) {
                const {
                    prejoinScreenDetail,
                    prejoinDeviceConnection,
                    remoteDeviceId,
                    availableUserIp
                } = getStore(FEATURE_CUSTOM_REDUX_V2)

                const {
                    showDevicePreConnection
                } = getStore(FEATURE_CUSTOM_REDUX_V3)

                if (parsedData.action.publicIp == publicIp || availableUserIp.indexOf(parsedData.action.publicIp) != -1) {
                    // rejoin user if already connected with device from prejoin screen
                    if (prejoinScreenDetail.isSet && conferenceJoined && parsedData.action.device_arr.indexOf(uniqueId) != -1) {
                        dispatch(setPrejoinScreenDetail({
                            isSet: false,
                            roomname: "",
                            uniqueId: "",
                            scope: "device was paired on prejoin screen websocket device reconnecting ABC"
                        }))
                        // window.isReconnecting = true;
                        // reconnect after 30 sec
                        if (!showDevicePreConnection) {
                            dispatch(showApiLoader({
                                loaderAdditionalDetail: ct("Translate.messages.deviceConnecting"),
                            }));
                        }
                        setTimeout(async function () {
                            let roomorIpAddressNew = showDevicePreConnection ? TEMP_ROOM : roomorIpAddress;
                            const obj = {
                                uniqueId: uniqueId,
                                room: roomorIpAddressNew
                            }

                            dispatch(setData(obj))

                            const message = {
                                action: {
                                    uniqueID: uniqueId,
                                    ipAddress: roomorIpAddressNew,
                                    protocolId: timeStamp
                                },
                                content: 'unique_check',
                                isBroadcast: true,
                                sender: 'mobile',
                                scope: "20"
                            };
                            //-------------Prepare logger data -------------
                            var log_data = {
                                functionName: '',
                                triggeredBy: 'system',
                                event: message.content,
                                requestData: message,
                                responseData: '',
                                userId: '',
                                boxId: message.action.uniqueID || ' available',
                                message: 'Emit to server'
                            }
                            SaveLog(log_data);
                            // -------------------------------------------
                            if (!showDevicePreConnection) {
                                sendData(message, {
                                    loaderAdditionalDetail: ct("Translate.messages.deviceConnecting"),
                                    type: 2
                                });

                            }

                        }, 30000)
                        setTimeout(() => {
                            dispatch(hideApiLoader());
                            const { usersData, conferenceJoined } = getStore(FEATURE_CUSTOM_REDUX);
                            if (!usersData) {
                                setTimeout(function () {
                                    dispatch(setDeviceContainerStatus("closeDevices", 'devices'))
                                    setTimeout(function () {
                                        dispatch(showToastPopup({ toastModal: false, modalText: "" }));
                                    }, 20000)
                                }, 1000)
                            }
                        }, 60000);
                    }

                    if (prejoinDeviceConnection == prejoinDetectDeviceEmitter.SOC_RECEIVED) {
                        if (remoteDeviceId) {
                            if (parsedData.action.device_arr.indexOf(remoteDeviceId) != -1) {
                                dispatch(setPrejoinDeviceConnection(prejoinDetectDeviceEmitter.DV_RECEIVED))
                            }
                        } else {
                            dispatch(setPrejoinDeviceConnection(prejoinDetectDeviceEmitter.DV_RECEIVED))
                        }
                    }

                    // dispatch(setDeviceListData({
                    //     deviceList: parsedData.action.device_arr ? parsedData.action.device_arr : [],
                    // }));
                    dispatch(saveDeviceListBase({ deviceList: parsedData.action.device_arr ? parsedData.action.device_arr : [] }))

                    if (parsedData.action.status == true) {
                        // if (isUserLogin) {
                        if (conferenceJoined == true) {
                            if (usersData == undefined || usersData?.uniqueID != localStorage?.getItem("uniqueID")) {
                                let { serverConnectRehit } = getStore(FEATURE_CUSTOM_REDUX_V3)
                                if (!serverConnectRehit) {
                                    dispatch(setEnableWebjamModal(true))
                                } else {
                                    dispatch(showApiLoader({
                                        loaderAdditionalDetail: ct("Translate.messages.serverConnectRehitLoader"),
                                    }));
                                }
                            }
                        }
                        // }
                    }
                }
            }
            //new-host-ready
            if (parsedData && parsedData.action && parsedData.content == "new-host-ready") {
                let curRoom = roomorIpAddress;
                if (_ValidateIPaddress(curRoom)) {
                    if (curRoom && curRoom.includes('_')) {
                        curRoom = curRoom.replace("_", ":")
                    }
                }
                let {
                    isDeviceConnecting
                } = getStore(FEATURE_CUSTOM_REDUX_V3)

                if (!isDeviceConnecting) {
                    dispatch(setIsDeviceConnecting(true))

                    setTimeout(function () {
                        dispatch(setIsDeviceConnecting(false))
                    }, 30000)

                    if ((usersData == null || usersData == undefined) && parsedData && parsedData.action && parsedData.action.ipAddress == curRoom) {

                        if (!localStorage.getItem("uniqueID")) {
                            dispatch(hideApiLoader())
                            return false;
                        }

                        dispatch(setData({
                            uniqueId: localStorage.getItem("uniqueID"),
                            room: curRoom
                        }));

                        dispatch(hideApiLoader(""));
                        if (hostTimer) {
                            clearTimeout(hostTimer);
                        }

                        var message = {
                            action: {
                                ipAddress: curRoom,
                                uniqueID: uniqueId ? uniqueId : localStorage.getItem("uniqueID"),
                                protocolId: timeStamp,
                            },
                            content: 'unique_check',
                            isBroadcast: true,
                            sender: 'mobile',
                            scope: "6"

                        };

                        //-------------Prepare logger data -------------
                        var log_data = {
                            functionName: '',
                            triggeredBy: 'system',
                            event: message.content,
                            requestData: message,
                            responseData: '',
                            userId: '',
                            boxId: message.action.uniqueID || ' available',
                            message: 'Emit to server'
                        }
                        SaveLog(log_data);
                        //-------------------------------------------

                        client.send(JSON.stringify(message));
                        dispatch(showApiLoader("server-connect", {
                            loaderAdditionalDetail: ct("Translate.messages.deviceConnecting"),
                            type: 11
                        }));

                        setTimeout(function () {
                            dispatch(hideApiLoader("server-connect"));
                            // localStorage.removeItem("newRoomHosted");
                        }, 30000)

                        //TO OPEN MIXER BY DEFAULT AFTER AUTOCONNECTING DEVICE
                        localStorage.setItem("autopopup", "auto-popup");
                        // HIDE DEVICE POP TILL "new host ready" event is not getting

                        // Hide webjam connected message
                        dispatch(setHideWebjamConnectedMessage(true))
                        setTimeout(function () {
                            dispatch(setHideWebjamConnectedMessage(false))
                        }, 30000)

                    } else {

                        //TO OPEN MIXER BY DEFAULT AFTER AUTOCONNECTING DEVICE
                        localStorage.setItem("autopopup", "auto-popup");
                        // HIDE DEVICE POP TILL "new host ready" event is not getting
                    }
                }
            }

            // Metronome started
            if (parsedData && parsedData.action && parsedData.content == "metronome-started") {
                if (parsedData &&
                    parsedData.action.uniqueID == uniqueId &&
                    parsedData.action.protocolID == timeStamp) {
                    if (parsedData && parsedData.action && parsedData.action.users && parsedData.action.users.length > 0) {
                        hideLoader("metronome-started");
                        dispatch(setMetronomeStatus({
                            showBox: true,
                            metronomeStatus: true,
                            metronomeTimerStatus: true
                        }));

                        dispatch(setUsersData({
                            ...parsedData.action,
                            users: parsedData.action.users,
                            uniqueId,
                        }));
                    }
                }
            }

            // Metronome stop
            if (parsedData && parsedData.action && parsedData.content == "metronome-stopped") {
                if (parsedData &&
                    parsedData.action.uniqueID == uniqueId &&
                    parsedData.action.protocolID == timeStamp) {
                    if (parsedData && parsedData.action && parsedData.action.users && parsedData.action.users.length > 0) {
                        hideLoader("metronome-stopped");
                        dispatch(setMetronomeStatus({
                            showBox: true,
                            metronomeStatus: false,
                        }));

                        // dispatch(setUsersData({
                        //     ...parsedData.action,
                        //     users: parsedData.action.users,
                        //     uniqueId,
                        // }));
                    }
                }
            }

            // My metronome stopped
            if (parsedData && parsedData.action && parsedData.content == "my-metronome-stopped") {
                if (parsedData &&
                    parsedData.action.uniqueID == uniqueId &&
                    parsedData.action.protocolID == timeStamp) {
                    if (parsedData && parsedData.action && parsedData.action.users && parsedData.action.users.length > 0) {
                        hideLoader("my-metronome-stopped");
                        dispatch(setMetronomeStatus({
                            showBox: true,
                            metronomeStatus: false,
                        }));

                        // dispatch(setUsersData({
                        //     ...parsedData.action,
                        //     users: parsedData.action.users,
                        //     uniqueId,
                        // }));
                    }
                }
            }

            // Bpm-update
            if (parsedData && parsedData.action && parsedData.content == "bpm-update") {
                if (parsedData &&
                    parsedData.action.uniqueID == uniqueId &&
                    parsedData.action.protocolID == timeStamp) {
                    if (parsedData && parsedData.action && parsedData.action.users && parsedData.action.users.length > 0) {
                        hideLoader("bpm-update");
                        dispatch(setUsersData({
                            ...parsedData.action,
                            users: parsedData.action.users,
                            uniqueId,
                        }));
                    }
                }
            }

            // UNPAIR WEBJAM DEVICE :-
            // if (parsedData &&
            //     parsedData.action &&
            //     parsedData.content == "device-unpaired" &&
            //     parsedData.action.uniqueID == uniqueId &&
            //     parsedData.action.protocolID == timeStamp
            // ) {
            //     dispatch(setUsersData(null));
            //     dispatch(setData({
            //         uniqueId: '',
            //         room: ''
            //     }));
            //     // UPDATE REDUCER FOR GHOST VOICESYNC:
            //     dispatch(setGhostVoiceSync(false));
            //     dispatch(setMetronomeStatus({ showBox: false }));
            //     dispatch(setAudioMuted(false));
            //     dispatch(setShowHideStatusWebJamMenu({
            //         isFromWebJam: false,
            //     }));
            //     dispatch(setUserConnectionStatus({
            //         isConnected: false,
            //         isHelpModal: true,
            //     }));
            // }

            // UNPAIR HOST WEBJAM DEVICE :-
            if (parsedData &&
                parsedData.action &&
                parsedData.content == "host-device-unpaired" &&
                parsedData.action.uniqueID == uniqueId &&
                parsedData.action.protocolID == timeStamp
            ) {
                if (!getBaseConfig("hostHangupNew")) {
                    dispatch(setUsersData(null));
                    // UPDATE REDUCER FOR GHOST VOICESYNC:
                    dispatch(setGhostVoiceSync(false));
                    dispatch(setMetronomeStatus({ showBox: false }));
                    dispatch(setAudioMuted(false));
                    dispatch(setUserConnectionStatus({
                        isConnected: false,
                        isHelpModal: true,
                    }));
                }
            }

            // Receive the stem recording(box recording) event and show along with jitsi recording
            if (parsedData &&
                parsedData.action &&
                parsedData.content == "hide-stem-recording" &&
                (parsedData.action.deviceId == uniqueId || parsedData.action.roomName == roomorIpAddress)
            ) {

                //-------------Prepare logger data -------------
                var log_data = {
                    functionName: '',
                    triggeredBy: 'system',
                    event: parsedData.content,
                    requestData: parsedData,
                    responseData: '',
                    userId: '',
                    boxId: (parsedData.action && parsedData.action.uniqueID) ? parsedData.action.uniqueID : '',
                    message: 'Listen to client'
                }
                SaveLog(log_data);
                //-------------------------------------------

                let data = parsedData.action;
                if (data.location == window.location.origin) {
                    if (data.roomName == usersData?.hostAddress || data.roomName == roomorIpAddress) {
                        dispatch(setStemRecordingUrl(data.url));
                        dispatch(showToastPopup({ toastModal: false, modalText: '' }));
                    }
                }
            }

            if (parsedData && parsedData.action && parsedData.content == "enabled-delay-panning") {
                if (parsedData && parsedData.action.room == roomorIpAddress && usersData) {
                    dispatch(hideApiLoader());
                    const { delayPanning } = getStore(FEATURE_CUSTOM_REDUX);
                    if (delayPanning != PANNING_VAR.DELAY_PANNING) {
                        sessionStorage.setItem("c_" + roomorIpAddress, 1)

                        dispatch(setDelayPanning(PANNING_VAR.DELAY_PANNING, parsedData.action));
                        var { local } = getStore("features/base/participants");
                        if (parsedData.action.jitsiId != local.id) {
                            dispatch(showToastPopup({ toastModal: true, modalText: parsedData.action.name + ct("Translate.messages.delayPanningParticipantEnable") }));

                            setTimeout(function () {
                                dispatch(showToastPopup({ toastModal: false, modalText: '' }));
                            }, 5000)
                        }
                    }
                }
            }

            if (parsedData && parsedData.action && parsedData.content == "disabled-delay-panning") {
                if (parsedData && parsedData.action.room == roomorIpAddress && usersData) {

                    var { local } = getStore("features/base/participants");
                    // if (parsedData.action.deviceId == uniqueId || sessionStorage.getItem("c_" + roomorIpAddress) != undefined) {
                    if (sessionStorage.getItem("c_" + roomorIpAddress) != undefined) {
                        if (sessionStorage.getItem("c_" + roomorIpAddress)) {
                            if (parsedData.action?.jitsiId != local.id) {
                                dispatch(showToastPopup({ toastModal: true, modalText: parsedData.action.name + ct("Translate.messages.delayPanningParticipantDisable") }));

                                setTimeout(function () {
                                    dispatch(showToastPopup({ toastModal: false, modalText: '' }));
                                }, 5000)
                            }

                        }
                        dispatch(hideApiLoader());
                        dispatch(setDelayPanning(parsedData.action.panning_name, parsedData.action));
                    }
                }
            }

            // Check if any user is connected with device in current room and save the user host detail
            if (parsedData &&
                parsedData.action &&
                parsedData.content == "users-list" &&
                (parsedData.action.roomName == roomorIpAddress || parsedData.action.roomName == room)
            ) {

                //-------------Prepare logger data -------------
                var log_data = {
                    functionName: '',
                    triggeredBy: 'system',
                    event: parsedData.content,
                    requestData: parsedData,
                    responseData: '',
                    userId: '',
                    boxId: (parsedData.action && parsedData.action.uniqueID) ? parsedData.action.uniqueID : '',
                    message: 'Listen to client'
                }
                SaveLog(log_data);
                //-------------------------------------------

                if (parsedData.action.users && parsedData.action.users.length) {
                    dispatch(setUsersListArray(parsedData.action.users))
                    for (let i = 0; i < parsedData.action.users.length; i++) {
                        if (parsedData.action.users[i].isHost == true) {
                            let pay = parsedData.action.users[i];
                            pay.myName = pay.name;
                            dispatch(setDeviceUsers(pay));
                            break;
                        }
                    }
                } else {
                    dispatch(setUsersListArray([]))
                }
            }

            // Check if any user is connected with device in current room and save the user host detail
            if (parsedData &&
                parsedData.action &&
                // parsedData.content == "manage-host-data" &&
                parsedData.content == "manage-host-data-new" &&
                (parsedData.action.ipAddress == roomorIpAddress || parsedData.action.ipAddress == room)
            ) {
                if (parsedData.action.users && parsedData.action.users.length) {
                    // dispatch(setUsersListArray(parsedData.action.users))
                    for (let i = 0; i < parsedData.action.users.length; i++) {
                        if (parsedData.action.users[i].isHost == true) {
                            dispatch(setDeviceUsers(parsedData.action.users[i]));
                            break;
                        }
                    }
                }
            }

            // Check if host is disconnected with device in current room and remove the user host detail
            if (parsedData && parsedData.content == "device-unpaired") {
            }

            // if (parsedData
            //     && parsedData.action
            //     && parsedData.content == "device-unpaired"
            //     && parsedData.action.uniqueID == uniqueId
            //     // && ( (parsedData.action.hostedRoom == roomorIpAddress || parsedData.action.hostAddress == roomorIpAddress))
            // ) {
            //     let hostedDevice = parsedData.action.uniqueID;
            //     const { devicesUsers } = getStore(FEATURE_CUSTOM_REDUX);
            //     if (devicesUsers.uniqueId == hostedDevice) {
            //         dispatch(setDeviceUsers(''));
            //     }
            //     dispatch(setUsersListArray([]));
            //     dispatch(setData({
            //         uniqueId: '',
            //         room: ''
            //     }));

            //     // new added
            //     dispatch(setUsersData(null));

            //     // UPDATE REDUCER FOR GHOST VOICESYNC:
            //     dispatch(setGhostVoiceSync(false));
            //     dispatch(setMetronomeStatus({ showBox: false }));
            //     dispatch(setAudioMuted(false));
            //     dispatch(setShowHideStatusWebJamMenu({
            //         isFromWebJam: false,
            //     }));
            //     dispatch(setUserConnectionStatus({
            //         isConnected: false,
            //         isHelpModal: true,
            //     }));

            //     // when prejoin meeting device is unpaired
            //     let { prejoinScreenDetail } = getStore(FEATURE_CUSTOM_REDUX_V2);
            //     if (prejoinScreenDetail.isSet) {
            //         dispatch(setPrejoinScreenDetail({
            //             isSet: false,
            //             roomname: "",
            //             uniqueId: "",
            //             scope: "device was paired on prejoin screen websocket"
            //         }))
            //     }

            //     // removed uniqueID from localstorage if device unpaired
            //     let unPairTime = sessionStorage.getItem("unpair");
            //     if (unPairTime) {
            //         if (calculateTimeDiff(unPairTime, 30)) {
            //             localStorage.removeItem("uniqueID")
            //             sessionStorage.removeItem("unpair")
            //         }
            //     }
            // }
            if (parsedData
                && parsedData.action
                && parsedData.content == "device-unpaired"
                && parsedData.action.uniqueID == uniqueId
                // && ( (parsedData.action.hostedRoom == roomorIpAddress || parsedData.action.hostAddress == roomorIpAddress))
            ) {
                let hostedDevice = parsedData.action.uniqueID;
                const { devicesUsers } = getStore(FEATURE_CUSTOM_REDUX);
                if (devicesUsers.uniqueId == hostedDevice) {
                    dispatch(setDeviceUsers(''));
                }
                dispatch(setUsersListArray([]));

                // new added
                dispatch(setUsersData(null));

                // UPDATE REDUCER FOR GHOST VOICESYNC:
                dispatch(setGhostVoiceSync(false));
                dispatch(setMetronomeStatus({ showBox: false }));
                dispatch(setAudioMuted(false));
                dispatch(setShowHideStatusWebJamMenu({
                    isFromWebJam: false,
                }));
                dispatch(setUserConnectionStatus({
                    isConnected: false,
                    isHelpModal: true,
                }));

                // when prejoin meeting device is unpaired
                // we are reconnecting device when device comes in list after prejoin screen,
                // if device is not comes in list till 60 sec the remove this flag;
                // let getUserSubs = userHasSubscription(true, "webjam")

                let isSubscriptionReq = getBaseConfig("subscriptionRequired");
                let willJoin = true;

                let curTime = Math.round(new Date().getTime() / 1000);
                let { userPaymentSubscription } = getStore(FEATURE_CUSTOM_PAYMENT)
                let { userLoginData } = getStore(FEATURE_CUSTOM_REDUX)

                let hasSubscription = false;

                if (userPaymentSubscription.pack_id) {
                    hasSubscription = true;
                    if (userPaymentSubscription.is_canceled == false) {
                        if (userPaymentSubscription.end_at < curTime) {
                            hasSubscription = false;
                        } else {
                            hasSubscription = true;
                        }
                    } else {
                        if (userPaymentSubscription.is_canceled) {
                            if (userPaymentSubscription.end_at > curTime) {
                                hasSubscription = true;
                            }
                        } else {
                            hasSubscription = false;
                        }
                    }
                }


                // const {
                //     userLoginData,
                //     userPaymentSubscription
                // } = this.props;

                if (isSubscriptionReq == true) {
                    willJoin = false
                    if (hasSubscription) {
                        willJoin = true;
                        if (userLoginData?.user?.id) {
                            if (!userPaymentSubscription.is_premium) {
                                willJoin = false;
                                dispatch(setTourGuideType(tourGuideActions.USER_HAS_BASIC_SUBSCRIPTION))
                            } else {
                                dispatch(setTourGuideType(tourGuideActions.USER_HAS_PREMIUM_SUBSCRIPTION))
                            }
                        }
                    } else {
                        if (!userLoginData?.user?.id) {
                            willJoin = false;
                        }
                    }
                }

                let { prejoinScreenDetail } = getStore(FEATURE_CUSTOM_REDUX_V2);
                if (willJoin) {
                    setTimeout(function () {
                        if (prejoinScreenDetail.isSet) {
                            dispatch(setPrejoinScreenDetail({
                                isSet: false,
                                roomname: "",
                                uniqueId: "",
                                scope: "device was paired on prejoin screen websocket"
                            }))
                        }
                    }, 90000)
                    setTimeout(function () {
                        if (prejoinScreenDetail.isSet) {
                            dispatch(setAudioMuted(true));
                            dispatch(setIsPreJoinAudioToMute(true));
                        }
                    }, 200)
                } else {
                    if (prejoinScreenDetail.isSet) {
                        dispatch(setPrejoinScreenDetail({
                            isSet: false,
                            roomname: "",
                            uniqueId: "",
                            scope: "device was paired on prejoin screen websocket 2"
                        }))
                    }
                    dispatch(setData({
                        uniqueId: '',
                        room: ''
                    }));
                    localStorage.removeItem("uniqueID");
                    dispatch(hideApiLoader());
                }

                // removed uniqueID from localstorage if device unpaired
                let unPairTime = sessionStorage.getItem("unpair");
                if (unPairTime) {
                    if (calculateTimeDiff(unPairTime, 30)) {
                        localStorage.removeItem("uniqueID")
                        sessionStorage.removeItem("unpair")
                    }
                }

                let { deviceContainerStatus } = getStore(FEATURE_CUSTOM_REDUX_V2)
                if (deviceContainerStatus == "unpairWebjam") {
                    setTimeout(() => {
                        dispatch(hideApiLoader());
                    }, 3000)
                }
            }

            if (parsedData
                && parsedData.action
                && parsedData.content == "server-disconnect"
                && (parsedData.action.hostedRoom == roomorIpAddress || parsedData.action.hostAddress == roomorIpAddress)
            ) {

                //-------------Prepare logger data -------------
                // var log_data = {
                //     functionName: '',
                //     triggeredBy: 'system',
                //     event: parsedData.content,
                //     requestData: parsedData,
                //     responseData: '',
                //     userId: '',
                //     boxId: (parsedData.action && parsedData.action.uniqueID) ? parsedData.action.uniqueID : '',
                //     message: 'Listen to client'
                // }
                // SaveLog(log_data);
                //-------------------------------------------

                let hostedDevice = parsedData.action.uniqueID;
                const { devicesUsers } = getStore(FEATURE_CUSTOM_REDUX);
                if (devicesUsers.uniqueId == hostedDevice) {
                    dispatch(setDeviceUsers(''));
                }
            }

            // MANAGE HOST EVENT LISTENER :-
            if (parsedData
                && parsedData.action
                // && parsedData.content == "manage-host-data"
                && parsedData.content == "manage-host-data-new"
                && (parsedData.action.ipAddress == roomorIpAddress || parsedData.action.ipAddress == CURRENT_ROOM_NAME)
                // parsedData.action.uniqueID == uniqueId &&
                // && parsedData.action.protocolID == timeStamp
            ) {
                let noChangedRoomName = getBaseConfig('noChangedRoomName')
                let curRoom = roomorIpAddress;
                if (noChangedRoomName == true) {
                    if (_ValidateIPaddress(curRoom)) {
                        if (curRoom && curRoom.includes('_')) {
                            curRoom = curRoom.replace("_", ":")
                        }
                    }
                }

                if (parsedData.action.ipAddress == curRoom && usersData) {
                    dispatch(setHostTabDataMain({
                        users: parsedData.action.users,
                        hostRcvResponse: true,
                        auto: parsedData.action.auto,
                        autoHost: parsedData.action?.autoHost
                    }));

                    dispatch(setAutoMakeHost({
                        //isAutoMakeHost: false,
                        isAutoMakeModal: false,
                        isAutoMakeHostUniqueId: '',
                    }));

                    // dispatch(setHostRefresh(false));
                    dispatch(setHostRefreshTimer(false));
                    dispatch(setHostInitWait(false));

                    // Click on auto manage host checkbox when received data
                    // if (parsedData.action.hasOwnProperty("autoHost")
                    //     && parsedData.action.autoHost
                    //     && parsedData.action.auto
                    //     && clickedAutoMakeHost) {

                    if (parsedData.action.users && parsedData.action.users.length == 1) {
                        if (parsedData.action?.autoHost || clickedAutoMakeHost) {
                            // dispatch(clickAutoMakeHost({ clickedAutoMakeHost: clickedAutoMakeHost }, 'manage-host-data 1'));
                            dispatch(clickAutoMakeHost({ clickedAutoMakeHost: clickedAutoMakeHost }, 'manage-host-data-new 1'));
                            if (parsedData.action.autoHost || clickedAutoMakeHost) {
                                sessionStorage.setItem("uniqueID", localStorage.getItem("uniqueID"));
                            } else {
                                sessionStorage.removeItem("uniqueID");
                            }
                        }
                    } else if (parsedData.action.hasOwnProperty("autoHost")
                        && parsedData.action.auto) {
                        // dispatch(clickAutoMakeHost({ clickedAutoMakeHost: parsedData.action.autoHost }, 'manage-host-data 2'));
                        if (parsedData.action.autoHost == null) {
                            dispatch(clickAutoMakeHost({ clickedAutoMakeHost: clickedAutoMakeHost }, 'manage-host-data-new 2 null'));
                        } else {
                            dispatch(clickAutoMakeHost({ clickedAutoMakeHost: parsedData.action.autoHost }, 'manage-host-data-new 2'));
                        }

                        if (parsedData.action.autoHost) {
                            sessionStorage.setItem("uniqueID", localStorage.getItem("uniqueID"));
                        } else {
                            sessionStorage.removeItem("uniqueID");
                        }
                    }

                    if (parsedData.action.users && parsedData.action.auto && clickedAutoMakeHost) {
                        let newRecommended = parsedData.action.users.find(o => o.isRecommended == true);
                        if (newRecommended && newRecommended.uniqueId) {
                            let iamIp = false;
                            if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(room)) {
                                iamIp = true;
                            }

                            if (!iamIp && usersData && usersData.isHost && newRecommended.uniqueId != uniqueId) {
                                dispatch(setAutoMakeHost({
                                    //isAutoMakeHost: true,
                                    isAutoMakeModal: true,
                                    isAutoMakeHostUniqueId: newRecommended.uniqueId,
                                }));
                            } else if (iamIp && newRecommended.uniqueId == uniqueId) {
                                dispatch(setAutoMakeHost({
                                    //isAutoMakeHost: true,
                                    isAutoMakeModal: true,
                                    isAutoMakeHostUniqueId: newRecommended.uniqueId,
                                }));

                            } else {
                            }
                        } else {
                        }
                    }
                }
            }



            // MANAGE HOST DISCONNECT EVENT LISTENER
            if (
                parsedData &&
                parsedData.action &&
                parsedData.content &&
                parsedData.content == 'make-host-disconnect'
                && conferenceJoined
            ) {
                let iamIp = false;
                if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(room)) {
                    iamIp = true;
                }

                if (usersData != null && parsedData.action.uniqueID == uniqueId || parsedData.action.uniqueID == localStorage.getItem("uniqueID")) {
                    dispatch(showApiLoader({
                        loaderAdditionalDetail: ct("Translate.messages.makeHostConnecting"),
                    }));
                }

                localStorage.setItem("makeHostConnect", 'true');
                dispatch(setHostInitWait(true));
                dispatch(setShowConnectPopup(false));
                setTimeout(() => {
                    dispatch(setShowConnectPopup(true));
                }, 30000);

                if (usersData != null &&
                    parsedData.action.protocolID == timeStamp &&
                    (parsedData.action.uniqueID == uniqueId || parsedData.action.uniqueID == localStorage.getItem("uniqueID"))
                ) {
                    dispatch(setIsDisconnectListened(true))
                    dispatch(setclickMakeHost(true));
                    dispatch(showApiLoader({
                        loaderAdditionalDetail: ct("Translate.messages.deviceConnecting"),
                    }));

                    // if (usersData != null && !usersData.isHost) {
                    //     if (iamIp && parsedData.action.newRoomName) {
                    //         showAppToast(`Room name changed from ${room} to ${parsedData.action.newRoomName}`, Constant.App.ToastTime.LongCloseTime);
                    //     } else {
                    //         showAppToast(ct("Translate.messages.otherMakeHostConnect"), 5000);
                    //         dispatch(showToastPopup({ toastModal: true, modalText: ct("Translate.messages.otherMakeHostConnect") }));
                    //         setTimeout(() => {
                    //             dispatch(showToastPopup({ toastModal: false, modalText: '' }));
                    //         }, 15000);
                    //     }
                    // }

                    dispatch(setUsersData(null));
                    dispatch(setGhostVoiceSync(false));
                    dispatch(setMetronomeStatus({ showBox: false }));
                    dispatch(setAudioMuted(false));
                    dispatch(setShowHideStatusWebJamMenu({
                        isFromWebJam: false,
                    }));
                    dispatch(setUserConnectionStatus({
                        isConnected: false,
                        isHelpModal: true,
                    }));

                    hostTimer = setTimeout(() => {
                        hideLoader("make-host-disconnect");
                        if (hostTimer) {
                            clearTimeout(hostTimer);
                        }

                        let noChangedRoomName = getBaseConfig('noChangedRoomName')
                        let roomorIpAddressNew = room ? room : roomorIpAddress
                        if (noChangedRoomName == true) {
                            roomorIpAddressNew = roomorIpAddress
                            if (roomorIpAddressNew && roomorIpAddressNew.indexOf("_") != -1) {
                                roomorIpAddressNew = roomorIpAddressNew.replace("_", ":")
                            }
                        }
                    }, 15000);

                    setTimeout(() => {
                        if (hostTimer) {
                            clearTimeout(hostTimer);
                            hideLoader("make-host-disconnect");
                            dispatch(showToastPopup({ toastModal: false, modalText: '' }));
                        }
                    }, 30000);

                    if (parsedData.action.newHost == uniqueId) {
                        localStorage.setItem("connectPop", 'true')
                        localStorage.setItem("makeHost", 'true');
                        localStorage.setItem("autoConnect", 'true');
                        let noChangedRoomName = getBaseConfig('noChangedRoomName');
                        setTimeout(function () {
                            dispatch(setAudioMuted(true));
                            dispatch(setIsPreJoinAudioToMute(true));
                        }, 200)

                        if (noChangedRoomName == true) {
                            dispatch(setLocalAutoConnect(true));
                        }

                        localStorage.setItem("uniqueID", uniqueId);
                        localStorage.setItem("timeStamp", timeStamp);

                        const { clickedAutoMakeHost } = getStore(FEATURE_CUSTOM_REDUX);
                        if (clickedAutoMakeHost) {
                            sessionStorage.setItem("isUserMakeHost", 'true');
                        }
                    } else {
                        localStorage.setItem("newRoomHosted", 'true')
                        setTimeout(function () {
                            dispatch(setAudioMuted(true));
                            dispatch(setIsPreJoinAudioToMute(true));
                        }, 200)
                    }

                    if (parsedData.action.newRoomName != '') {
                        localStorage.setItem("windowRedirect", 'true');
                        dispatch(setData({
                            uniqueId: uniqueId,
                            room: parsedData.action.newRoomName
                        }));

                        let noChangedRoomName = getBaseConfig('noChangedRoomName')
                        if (noChangedRoomName == true) {
                            let newRoomName = parsedData.action.newRoomName;
                            if (newRoomName) {
                                if (_ValidateIPaddress(newRoomName)) {
                                    if (newRoomName.indexOf("_") != -1) {
                                        newRoomName = newRoomName.replace("_", ":")
                                    }
                                }
                            }
                            dispatch(setRoomorIpAddress(newRoomName, 'make-host-disconnect'));
                            const { hostHangupEventReceived } = getStore(FEATURE_CUSTOM_REDUX_V3);
                            if (hostHangupEventReceived) {
                                dispatch(setHostHangupAutoConnect(true, 'make-host-disconnect'));
                                setTimeout(() => {
                                    dispatch(setHostHangupAutoConnect(false, 'make-host-disconnect'));
                                }, 30000);
                            }
                        } else {
                            window.location.replace(`/${parsedData.action.newRoomName}`);
                        }
                    }
                }
                // Hide webjam connected message
                dispatch(setHideWebjamConnectedMessage(true))
                setTimeout(function () {
                    dispatch(setHideWebjamConnectedMessage(false))
                }, 60000)
            }

            // Third Party Make Host User :-
            if (parsedData &&
                parsedData.action &&
                parsedData.content == "third-party-server" &&
                (parsedData.action.roomName == roomorIpAddress || parsedData.action.roomName == CURRENT_ROOM_NAME)
            ) {
                let noChangedRoomName = getBaseConfig('noChangedRoomName')
                let curRoom = roomorIpAddress;
                if (noChangedRoomName == true) {
                    if (_ValidateIPaddress(curRoom)) {
                        if (curRoom && curRoom.includes('_')) {
                            curRoom = curRoom.replace("_", ":")
                        }
                    }
                }
                if (parsedData.action.roomName == curRoom) {
                    let data = {
                        isRecommended: false,
                        isHost: false,
                        isThirdParty: true,
                        ...parsedData.action
                    }
                    dispatch(setThirdPartyHostTabData(data));
                }
            }

            // Third Party Disconnect Listener :-
            if (
                parsedData &&
                parsedData.action &&
                parsedData.content &&
                parsedData.content == 'third-party-disconnect'
                && conferenceJoined
            ) {
                let hostTabData = getStore(FEATURE_CUSTOM_REDUX).hostTabData
                let recHost = hostTabData?.users?.find(o => o.isRecommended == true);
                let localParticipant = getStore('features/base/participants').local;
                let isModerator = Boolean(localParticipant?.role === PARTICIPANT_ROLE.MODERATOR);
                let initRoom = parsedData.action.ipAddress;
                let propRoom = room;
                if (initRoom.includes(":")) {
                    initRoom = initRoom.replace(":", "_")
                }
                if (propRoom.includes(":")) {
                    propRoom = propRoom.replace(":", "_")
                }

                if (initRoom == propRoom) {
                    if (parsedData.action.uniqueID == uniqueId || parsedData.action.uniqueID == localStorage.getItem("uniqueID")) {
                        dispatch(showApiLoader({
                            loaderAdditionalDetail: ct("Translate.messages.makeHostConnecting"),
                        }));
                    }
                    dispatch(setThirdPartyModEvent(parsedData.action))
                    var { local } = getStore("features/base/participants");

                    let newRoomName = parsedData.action.newRoomName
                    let noChangedRoomName = getBaseConfig('noChangedRoomName')
                    if (noChangedRoomName == true) {
                        if (_ValidateIPaddress(newRoomName)) {
                            if (newRoomName && newRoomName.indexOf("_") != -1) {
                                newRoomName = newRoomName.replace("_", ":")
                            }
                        }
                    } else {
                        if (newRoomName.indexOf(":") != -1) {
                            newRoomName = newRoomName.replace(":", "_")
                        }
                    }

                    if (parsedData.action.newHost == '') {
                        // dispatch(setModeratorThirdPartyEventListened(true))
                        // localStorage.setItem("thirdPartyMakeHostConnect", 'true');
                    }
                    dispatch(setHostInitWait(true));

                    // if ((usersData != null &&
                    //     parsedData.action.protocolID == timeStamp &&
                    //     (parsedData.action.uniqueID == uniqueId || parsedData.action.uniqueID == localStorage.getItem("uniqueID"))
                    // ) && (_ValidateIPaddress(parsedData.action.newRoomName) && (recHost || isModerator))) {
                    if ((usersData != null &&
                        parsedData.action.protocolID == timeStamp &&
                        (parsedData.action.uniqueID == uniqueId || parsedData.action.uniqueID == localStorage.getItem("uniqueID"))
                    ) && (_ValidateIPaddress(parsedData.action.newRoomName))) {
                        dispatch(setIsDisconnectListened(true))
                        dispatch(setModeratorThirdPartyEventListened(true))
                        dispatch(setHostEventReceived(HOST_RECEIVED_EVENTS.THIRD_PARTY_RECEIVED));

                        setTimeout(function () {
                            dispatch(setHostEventReceived(""));
                        }, 50000)

                        dispatch(setclickMakeHost(true));
                        dispatch(showApiLoader({
                            loaderAdditionalDetail: ct("Translate.messages.deviceConnecting"),
                            type: 22
                        }));

                        // if ((usersData != null && !usersData.isHost) || (_ValidateIPaddress(parsedData.action.ipAddress) && (recHost || isModerator))) {
                        //     if (newRoomName == '') {
                        //         dispatch(showToastPopup({ toastModal: true, modalText: ct("Translate.messages.otherMakeHostConnect") }));
                        //         setTimeout(() => {
                        //             dispatch(showToastPopup({ toastModal: false, modalText: '' }));
                        //         }, 15000);
                        //     } else {
                        //         showAppToast(`Room name changed from ${room} to ${newRoomName}`, 5000);
                        //     }
                        // }

                        dispatch(setUsersData(null));
                        // UPDATE REDUCER FOR GHOST VOICESYNC:
                        dispatch(setGhostVoiceSync(false));
                        dispatch(setMetronomeStatus({ showBox: false }));
                        dispatch(setAudioMuted(false));
                        dispatch(setShowHideStatusWebJamMenu({
                            isFromWebJam: false,
                        }));
                        dispatch(setUserConnectionStatus({
                            isConnected: false,
                            isHelpModal: true,
                        }));

                        if ((parsedData.action.newHost == '' && usersData != null && usersData.isHost) || (_ValidateIPaddress(parsedData.action.ipAddress) && (recHost || isModerator))) {
                            localStorage.setItem("connectPop", 'true')
                            localStorage.setItem("makeHost", 'true');
                            localStorage.setItem("autoConnect", 'true');
                            let noChangedRoomName = getBaseConfig('noChangedRoomName')
                            if (noChangedRoomName == true) {
                                dispatch(setLocalAutoConnect(true));
                            }
                            localStorage.setItem("uniqueID", uniqueId);
                            localStorage.setItem("timeStamp", timeStamp);

                            const { clickedAutoMakeHost } = getStore(FEATURE_CUSTOM_REDUX);

                            if (clickedAutoMakeHost) {
                                sessionStorage.setItem("isUserMakeHost", 'true');
                            }

                        } else {
                            localStorage.setItem("newRoomHosted", 'true')
                            localStorage.setItem("connectPop", 'true')
                            setTimeout(function () {
                                dispatch(setAudioMuted(true));
                                dispatch(setIsPreJoinAudioToMute(true));
                            }, 200)
                        }
                        if (parsedData.action.changed == true) {
                            showAppToast(ct("Translate.messages.ipPortNotAvailable"), 3000);
                            dispatch(setThirdPartyModEvent(parsedData.action))
                        }
                        // if ((newRoomName != '' && usersData != null && usersData.isHost) || (_ValidateIPaddress(parsedData.action.ipAddress) && (recHost || isModerator))) {
                        if (newRoomName != '' && _ValidateIPaddress(parsedData.action.newRoomName)) {
                            // if (isModerator) {
                            //     socketEmit('third_party_moderator_connected', {
                            //         location: window.location.origin,
                            //         room: parsedData.action.newRoomName,
                            //         jitsiId: local.id
                            //     })
                            // }
                            localStorage.setItem("windowRedirect", 'true');
                            dispatch(setData({
                                uniqueId: uniqueId,
                                room: newRoomName
                            }));
                            let noChangedRoomName = getBaseConfig('noChangedRoomName')
                            if (noChangedRoomName == true) {
                                if (_ValidateIPaddress(newRoomName)) {
                                    if (newRoomName && newRoomName.indexOf("_") != -1) {
                                        newRoomName = newRoomName.replace("_", ":")
                                    }
                                }
                                dispatch(setRoomorIpAddress(newRoomName, 'third-party-disconnect'));
                                const { hostHangupEventReceived } = getStore(FEATURE_CUSTOM_REDUX_V3);
                                if (hostHangupEventReceived) {
                                    dispatch(setHostHangupAutoConnect(true, 'third-party-disconnect'));
                                    setTimeout(() => {
                                        dispatch(setHostHangupAutoConnect(false, 'third-party-disconnect'));
                                    }, 30000);
                                }
                            } else {
                                window.location.replace(`/${newRoomName}`);
                            }
                        }
                    }
                    setTimeout(() => {
                        dispatch(hideApiLoader());
                    }, 90000)
                }
                // Hide webjam connected message
                dispatch(setHideWebjamConnectedMessage(true))
                setTimeout(function () {
                    dispatch(setHideWebjamConnectedMessage(false))
                }, 60000)
            }

            // Buffer Delay :-
            if (
                parsedData &&
                parsedData.action &&
                parsedData.content &&
                parsedData.content == 'buffer-delay-disconnect' &&
                parsedData.action.roomName == roomorIpAddress
                // && (usersData != null || usersData != undefined)
            ) {
                let userRole = '';
                if (parsedData.action.hostId == uniqueId) {
                    //-------------Prepare logger data -------------
                    var log_data = {
                        functionName: '',
                        triggeredBy: 'system',
                        event: parsedData.content,
                        requestData: parsedData,
                        responseData: '',
                        userId: '',
                        boxId: (parsedData.action && parsedData.action.uniqueID) ? parsedData.action.uniqueID : '',
                        message: 'Listen to client'
                    }
                    SaveLog(log_data);
                    //-------------------------------------------
                    userRole = BUFFER_USER.HOST;
                } else if (parsedData.action.uniqueID == uniqueId) {
                    userRole = BUFFER_USER.PARTICIPANT;
                }
                if (userRole != "") {
                    dispatch(setIsEventRequestingLoader("bufferDelayChange"));
                    setTimeout(function () {
                        dispatch(setIsEventRequestingLoader(''))
                    }, 120000)

                    // Re-hit show loader so loaders don't break
                    setTimeout(function () {
                        dispatch(showApiLoader({ loaderAdditionalDetail: ct("Translate.messages.bufferDelayProcessing") }));
                    }, 2000)
                    setTimeout(function () {
                        dispatch(showApiLoader({ loaderAdditionalDetail: ct("Translate.messages.bufferDelayProcessing") }));
                    }, 10000)
                    // End

                    dispatch(setUsersData(null));
                    dispatch(setHostInitWait(true));
                    dispatch(showApiLoader({ loaderAdditionalDetail: ct("Translate.messages.bufferDelayProcessing") }));
                    setTimeout(function () {
                        dispatch(showApiLoader({ loaderAdditionalDetail: ct("Translate.messages.bufferDelayProcessingLate") }));
                    }, 60000)
                    dispatch(setIsBufferHostReady(true));
                    dispatch(setShowConnectPopup(false));
                    setTimeout(() => {
                        dispatch(setShowConnectPopup(true));
                    }, 60000);

                    // Hide webjam connected message
                    dispatch(setHideWebjamConnectedMessage(true))
                    setTimeout(function () {
                        dispatch(setHideWebjamConnectedMessage(false))
                    }, 60000)

                    if (userRole == BUFFER_USER.HOST) {
                        setTimeout(function () {
                            dispatch(setIsEventRequestingLoader(''))
                        }, 60000)
                        dispatch(setBufferChangeUser(true));

                        setTimeout(function () {
                            dispatch(setIsBufferChange(false))
                        }, 15000)

                        dispatch(setIsDeviceListed(true));

                        const message = {
                            action: {
                                uniqueID: parsedData.action.hostId,
                                ipAddress: roomorIpAddress,
                                protocolId: timeStamp
                            },
                            content: 'unique_check',
                            isBroadcast: true,
                            sender: 'mobile',
                            scope: "9"

                        };
                        // sendData(message);
                        let currentTime = Math.round(new Date().getTime() / 1000);
                        localStorage.setItem("bufferTimeout", currentTime);
                        setTimeout(function () {
                            let bufferTimerCheck = localStorage.getItem("bufferTimeout");
                            let bufferTimerCheckPlus = bufferTimerCheck + 5;
                            let bufferTimerCheckMinus = bufferTimerCheck - 5;
                            if (currentTime == bufferTimerCheck || currentTime < bufferTimerCheckPlus && currentTime > bufferTimerCheckMinus) {
                                let hostData = getStore(FEATURE_CUSTOM_REDUX).usersData;
                                if (!hostData || hostData == '') {
                                    dispatch(hideApiLoader());
                                    dispatch(showToastPopup({ toastModal: true, modalText: ct("Translate.messages.makeHostDisconnected") }));
                                    dispatch(setDeviceContainerStatus("CloseBufferDelayDisconnect", 'buffer-delay-disconnect 1'))
                                    dispatch(setShowConnectPopup(true));
                                } else {
                                    localStorage.removeItem("bufferTimeout");
                                }
                            }
                        }, 120000)
                    } else if (userRole == BUFFER_USER.PARTICIPANT) {
                        dispatch(setIsEventRequestingLoader("bufferDelayChange"));
                        // dispatch(setBufferChangeUser('bufferParticipant'));
                        dispatch(setShowConnectPopup('bufferParticipant'));
                        dispatch(showApiLoader({ loaderAdditionalDetail: ct("Translate.messages.bufferDelayProcessing") }));
                        setTimeout(function () {
                            dispatch(showApiLoader({ loaderAdditionalDetail: ct("Translate.messages.bufferDelayProcessingLate") }));
                        }, 60000)
                        toast(ct("Translate.messages.changingBufferDelay"), Constant.App.ToastTime.LongCloseTime)
                        setTimeout(function () {
                            let userData = getStore(FEATURE_CUSTOM_REDUX).usersData;
                            if (!userData || userData == '') {
                                setTimeout(() => {
                                    if (!userData || userData == '') {
                                        dispatch(hideApiLoader());
                                        dispatch(showToastPopup({ toastModal: true, modalText: ct("Translate.messages.hostInternetGone") }));
                                        dispatch(setShowConnectPopup(true));
                                    }
                                }, 7000)
                            }
                        }, 180000)
                        setTimeout(function () {
                            let userData = getStore(FEATURE_CUSTOM_REDUX).usersData;
                            let protocolId = getStore(FEATURE_CUSTOM_REDUX).protocolId
                            if (!userData || userData == '') {
                                const data = {
                                    action: {
                                        uniqueID: uniqueId,
                                        ipAddress: roomorIpAddress,
                                        protocolId,
                                    },
                                    content: 'unpair-device',
                                    isBroadcast: true,
                                    sender: 'mobile'
                                }

                                //-------------Prepare logger data -------------
                                var log_data = {
                                    functionName: '',
                                    triggeredBy: 'system',
                                    event: data.content,
                                    requestData: data,
                                    responseData: '',
                                    userId: '',
                                    boxId: data.action.uniqueID,
                                    message: 'Emit to server'
                                }
                                SaveLog(log_data);
                                //-------------------------------------------
                                sendData(data);
                                dispatch(setDeviceContainerStatus("CloseBufferDelayDisconnect", 'buffer-delay-disconnect 2'))
                                // dispatch(saveRoomEndValue(null));
                                dispatch(setUsersListArray([]));
                                // if (!userData || userData == '') {
                                dispatch(showToastPopup({ toastModal: false, modalText: "" }));
                                // window.location.href = window.location.origin;
                            }
                        }, 190000)
                    }
                }
            }

            // Buffer Host Ready :-
            if (
                parsedData &&
                parsedData.action &&
                parsedData.content &&
                parsedData.content == 'buffer-host-ready' &&
                parsedData.action.roomName == roomorIpAddress
            ) {
                // let userRole = '';
                // if (parsedData.action.hostId == uniqueId) {
                //     userRole = BUFFER_USER.HOST;
                // } else if (parsedData.action.uniqueID == uniqueId) {
                //     userRole = BUFFER_USER.PARTICIPANT;
                // }
                let userParticipant = getStore(FEATURE_CUSTOM_REDUX).usersData
                let isBufferHostReady = getStore(FEATURE_CUSTOM_REDUX_V2).isBufferHostReady
                if (userParticipant == null || userParticipant == undefined) {
                    if (isBufferHostReady) {
                        dispatch(setEnableWebjamModal(false));
                        dispatch(setIsEventRequestingLoader(''))
                        // if (userRole == BUFFER_USER.PARTICIPANT) {
                        const message = {
                            action: {
                                // uniqueID: parsedData.action.uniqueID,
                                uniqueID: uniqueId ? uniqueId : localStorage.getItem("uniqueID"),
                                ipAddress: roomorIpAddress,
                                protocolId: timeStamp
                            },
                            content: 'unique_check',
                            isBroadcast: true,
                            sender: 'mobile',
                            scope: "10"

                        };

                        //-------------Prepare logger data -------------
                        var log_data = {
                            functionName: '',
                            triggeredBy: 'system',
                            event: message.content,
                            requestData: message,
                            responseData: '',
                            userId: '',
                            boxId: message.action.uniqueID || ' available',
                            message: 'Emit to server'
                        }
                        SaveLog(log_data);
                        //-------------------------------------------

                        // Hide webjam connected message
                        dispatch(setHideWebjamConnectedMessage(true))
                        setTimeout(function () {
                            dispatch(setHideWebjamConnectedMessage(false))
                        }, 30000)
                        sendData(message);
                        dispatch(setIsBufferHostReady(false))
                    }
                }
            }

            // Prejoin meeting ping calculation
            if (
                parsedData &&
                parsedData.action &&
                parsedData.content &&
                parsedData.content == 'ping-calculated' &&
                parsedData.action.roomName == CURRENT_ROOM_NAME
            ) {
                let { usersData, conferenceJoined } = getStore(FEATURE_CUSTOM_REDUX);
                let { prejoinDevicePingCalculation } = getStore(FEATURE_CUSTOM_REDUX_V3);
                let willSet = false;
                if (parsedData.action.uniqueID) {
                    if (parsedData.action.uniqueID.indexOf(usersData.uniqueId) != -1) {
                        willSet = true;
                    }
                }

                // else {
                //     willSet = true;
                // }

                if (willSet) {
                    if ((!conferenceJoined || (getBaseConfig("showPreJoiningInConference") && conferenceJoined)) && CURRENT_ROOM_NAME.length > 1) {
                        if (prejoinDevicePingCalculation == prejoinDeviceCalculateFlag.WAITING) {
                            dispatch(setPrejoinDevicePingCalculate(prejoinDeviceCalculateFlag.RECEIVED))
                        }
                    }
                }
            }

            // Room not found event listener
            if (parsedData
                && parsedData.action
                && parsedData.content == "room-not-found-reboot"
            ) {
                let { conferenceJoined, roomorIpAddress, uniqueId } = getStore(FEATURE_CUSTOM_REDUX);
                let { showDevicePreConnection } = getStore(FEATURE_CUSTOM_REDUX_V3)

                if ((parsedData.action.ipAddress == roomorIpAddress || parsedData.action.ipAddress == CURRENT_ROOM_NAME)
                    && (parsedData.action.uniqueID == uniqueId || parsedData.action.uniqueID == localStorage.getItem("uniqueID"))
                    && conferenceJoined
                    && !showDevicePreConnection
                ) {
                    dispatch(hideApiLoader());
                    dispatch(showToastPopup({ toastModal: true, modalText: ct("rta-trmc.webSocket.noRoomFoundText") }));
                    setTimeout(function () {
                        dispatch(hideApiLoader());
                        dispatch(showToastPopup({ toastModal: false, modalText: "" }));
                    }, 20000)
                }
            }
        }
    }

    client.onerror = error => {
        dispatch(setSocketConnectionStatus({ isSocketConnected: false }))
        displayConsole('--------********** onerror **********-------', error);
    };

    client.onclose = error => {
        dispatch(setSocketConnectionStatus({ isSocketConnected: false }))
        displayConsole('--------********** onclose **********-------', error);
        modalState = toState(reducerState)[FEATURE_CUSTOM_REDUX];
        const { isInternetConnected } = modalState;
        if (isInternetConnected) {
            initWebSocket();
        }
    };

    return client;
};

export const getWebSocket = () => {
    displayConsole('--------********** getWebSocket **********-------', client);
    return client;
};

export const hideLoader = (value) => {
    const { isPreJoinAudioToMute } = getStore(FEATURE_CUSTOM_REDUX_V3);
    let usersData = getStore(FEATURE_CUSTOM_REDUX).usersData;
    if (timeoutLoader) {
        clearTimeout(timeoutLoader);
    }
    dispatch(hideApiLoader({
        value
    }));
    if (isPreJoinAudioToMute && (!usersData || usersData == '')) {
        dispatch(setAudioMuted(false));
        dispatch(setIsPreJoinAudioToMute(false));
    }

}
export const sendData = (message, loaderMsg, hideLoading = '') => {
    if (message.content == "unique_check") {
        if (!message.action.uniqueID
            || message.action.uniqueID == null
            || message.action.uniqueID == undefined
            || message.action.uniqueID == "null"
            || message.action.uniqueID == "undefined") {
            return false;
        }
    }

    let timeout = 150000;
    let timeUpdated = false;
    if (message.content !== 'start-metronome' && message.content !== 'set-volume' && message.content !== 'host-information' && message.content !== 'cancel-host-information' && message.content !== 'stop-latency') {
        //-------------Prepare logger data -------------
        var log_data = {
            functionName: '',
            triggeredBy: 'system',
            event: message.content,
            requestData: message,
            responseData: '',
            userId: '',
            boxId: (message.action && message.action.uniqueID) ? message.action.uniqueID : '',
            message: 'Listen to client'
        }
        SaveLog(log_data);
        //-------------------------------------------
        if (!hideLoading) {
            //dispatch(showApiLoader(loaderMsg ? loaderMsg : 'Loading...'));
            let loaderMeg = ct("Translate.messages.loading");
            if (loaderMsg) {
                loaderMeg = loaderMsg;
            }
            if (["server-connect", "buffer-delay", "unique_check"].indexOf(message.content) == -1) {
                if (loaderMeg?.loaderAdditionalDetail) {
                    loaderMeg.loaderAdditionalDetail = ""
                }
            } else {
                timeout = 150000;
                timeUpdated = true;
            }
            dispatch(showApiLoader(loaderMsg));
        }

        if (message.content == "server-connect") {
            let userName = getStore('features/base/participants').local?.name;
            if (!userName) {
                //userName = "RTA User";
                userName = "user";
            }
            var message = {
                action: {
                    firstname: userName,
                    lastname: '',
                    uniqueID: message.action.uniqueID,
                },
                content: 'set-name',
                isBroadcast: true,
                sender: 'mobile',
            };
            sendData(message);
        }
        if (timeoutLoader) {
            clearTimeout(timeoutLoader);
        }

        timeoutLoader = setTimeout(() => {
            dispatch(hideApiLoader());
            const { usersData, conferenceJoined } = getStore(FEATURE_CUSTOM_REDUX);
            const { showDevicePreConnection } = getStore(FEATURE_CUSTOM_REDUX_V3);
            if (timeUpdated && !usersData && !showDevicePreConnection) {
                setTimeout(function () {
                    let makeHostDisconnected = getBaseConfig("makeHostDisconnected") /* MMS */
                    if (conferenceJoined) {
                        dispatch(showToastPopup({ toastModal: true, modalText: makeHostDisconnected }));
                    }
                    setTimeout(function () {
                        dispatch(showToastPopup({ toastModal: false, modalText: "" }));
                    }, 20000)
                }, 1000)
            }
        }, timeout);
    }

    if (!client) {
        initWebSocket();
        let timer = setInterval(function () {
            if (client && client.readyState == WebSocket.OPEN) {
                client.send(JSON.stringify(message));
                clearInterval(timer);
            }
        }, 2000)
    } else if (client && client.readyState !== WebSocket.OPEN) {
        initWebSocket();
        let timer = setInterval(() => {
            if (client && client.readyState == WebSocket.OPEN) {
                client.send(JSON.stringify(message));
                clearInterval(timer);
            }
        }, 2000);
    } else {
        client.send(JSON.stringify(message));
    }
};